import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Duration5ynfiptaqcrg as Duration,
  listOfvhqybd2zx248 as listOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Enum3alwj03lh1n41 as Enum,
  contains1tccixv8iwdcq as contains,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  createThis2j2avj17cvnv2 as createThis,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  Signal3nnez3346azzf as Signal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  get_fast37cu8s8qwnuyi as get_fast,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_14,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_15,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_16,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_17,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_18,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_19,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_20,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_22,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  If1av5krmfyt44s as If,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Program1hnygp9hph4ry as Program,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_23,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_24,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_25,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_26,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_27,
  Rectangle3q03woyn9k8x1 as Rectangle,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_28,
  Scale2cm697xlulcp5 as Scale,
  Companion_getInstance2yu48324co92b as Companion_getInstance_29,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_30,
  RoundRectangle271svjyf7w51p as RoundRectangle,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_31,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_33,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_34,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  umod164hvijxhfi8p as umod,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_35,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.y9l_1 = Companion_getInstance_0().tx('Korge');
    this.z9l_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  a9m(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  wd(p1, $completion) {
    return this.a9m(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.m9k_1 = this$0;
    this.n9k_1 = $entry;
  }
  h1p($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_36();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_36().z9l_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().j8d_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().v8a_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_37().h3q() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().i3z_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().h3z_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.o9k_1 = args;
    this.p9k_1 = imageFormats;
    this.q9k_1 = gameWindow;
    this.r9k_1 = mainSceneClass;
    this.s9k_1 = timeProvider;
    this.t9k_1 = injector;
    this.u9k_1 = configInjector;
    this.v9k_1 = debug;
    this.w9k_1 = trace;
    this.x9k_1 = context;
    this.y9k_1 = fullscreen;
    this.z9k_1 = blocking;
    this.a9l_1 = gameId;
    this.b9l_1 = settingsFolder;
    this.c9l_1 = batchMaxQuads;
    this.d9l_1 = windowSize;
    this.e9l_1 = virtualSize;
    this.f9l_1 = displayMode;
    this.g9l_1 = title;
    this.h9l_1 = backgroundColor;
    this.i9l_1 = quality;
    this.j9l_1 = icon;
    this.k9l_1 = multithreaded;
    this.l9l_1 = forceRenderEveryFrame;
    this.m9l_1 = windowCreationConfig;
    this.n9l_1 = main;
    this.o9l_1 = debugAg;
    this.p9l_1 = debugFontExtraScale;
    this.q9l_1 = debugFontColor;
    this.r9l_1 = stageBuilder;
    this.s9l_1 = targetFps;
    this.t9l_1 = preferSyncIo;
    this.u9l_1 = debugCoroutines;
    this.v9l_1 = unit;
  }
  v9o(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  w9o(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  w9l(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.o9k_1 : args;
    imageFormats = imageFormats === VOID ? this.p9k_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.q9k_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.r9k_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.s9k_1 : timeProvider;
    injector = injector === VOID ? this.t9k_1 : injector;
    configInjector = configInjector === VOID ? this.u9k_1 : configInjector;
    debug = debug === VOID ? this.v9k_1 : debug;
    trace = trace === VOID ? this.w9k_1 : trace;
    context = context === VOID ? this.x9k_1 : context;
    fullscreen = fullscreen === VOID ? this.y9k_1 : fullscreen;
    blocking = blocking === VOID ? this.z9k_1 : blocking;
    gameId = gameId === VOID ? this.a9l_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.b9l_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.c9l_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.d9l_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.e9l_1 : virtualSize;
    displayMode = displayMode === VOID ? this.f9l_1 : displayMode;
    title = title === VOID ? this.g9l_1 : title;
    backgroundColor = backgroundColor === VOID ? this.h9l_1 : backgroundColor;
    quality = quality === VOID ? this.i9l_1 : quality;
    icon = icon === VOID ? this.j9l_1 : icon;
    multithreaded = multithreaded === VOID ? this.k9l_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.l9l_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.m9l_1 : windowCreationConfig;
    main = main === VOID ? this.n9l_1 : main;
    debugAg = debugAg === VOID ? this.o9l_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.p9l_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.q9l_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.r9l_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.s9l_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.t9l_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.u9l_1 : debugCoroutines;
    unit = unit === VOID ? this.v9l_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.w9o(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.w9o;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.o9k_1);
    var tmp_0 = this.p9k_1.toString();
    var tmp_1 = toString_0(this.q9k_1);
    var tmp_2 = toString_0(this.r9k_1);
    var tmp_3 = toString(this.s9k_1);
    var tmp_4 = this.t9k_1.toString();
    var tmp_5 = toString(this.u9k_1);
    var tmp_6 = toString_0(this.x9k_1);
    var tmp_7 = this.d9l_1.toString();
    var tmp_8 = this.e9l_1.toString();
    var tmp_9 = this.f9l_1.toString();
    var tmp_10 = this.h9l_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.v9k_1 + ', trace=' + this.w9k_1 + ', context=' + tmp_6 + ', fullscreen=' + this.y9k_1 + ', blocking=' + this.z9k_1 + ', gameId=' + this.a9l_1 + ', settingsFolder=' + this.b9l_1 + ', batchMaxQuads=' + this.c9l_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.g9l_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.i9l_1) + ', icon=' + this.j9l_1 + ', multithreaded=' + this.k9l_1 + ', forceRenderEveryFrame=' + this.l9l_1 + ', windowCreationConfig=' + this.m9l_1.toString() + ', main=' + toString(this.n9l_1) + ', debugAg=' + this.o9l_1 + ', debugFontExtraScale=' + this.p9l_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.q9l_1) + ', stageBuilder=' + toString(this.r9l_1) + ', targetFps=' + this.s9l_1 + ', preferSyncIo=' + this.t9l_1 + ', debugCoroutines=' + this.u9l_1 + ', unit=' + this.v9l_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.o9k_1);
    result = imul(result, 31) + hashCode(this.p9k_1) | 0;
    result = imul(result, 31) + (this.q9k_1 == null ? 0 : hashCode(this.q9k_1)) | 0;
    result = imul(result, 31) + (this.r9k_1 == null ? 0 : this.r9k_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.s9k_1) | 0;
    result = imul(result, 31) + hashCode(this.t9k_1) | 0;
    result = imul(result, 31) + hashCode(this.u9k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v9k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w9k_1) | 0;
    result = imul(result, 31) + (this.x9k_1 == null ? 0 : hashCode(this.x9k_1)) | 0;
    result = imul(result, 31) + (this.y9k_1 == null ? 0 : getBooleanHashCode(this.y9k_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a9l_1) | 0;
    result = imul(result, 31) + (this.b9l_1 == null ? 0 : getStringHashCode(this.b9l_1)) | 0;
    result = imul(result, 31) + this.c9l_1 | 0;
    result = imul(result, 31) + this.d9l_1.hashCode() | 0;
    result = imul(result, 31) + this.e9l_1.hashCode() | 0;
    result = imul(result, 31) + this.f9l_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g9l_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.h9l_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.h9l_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.i9l_1.hashCode() | 0;
    result = imul(result, 31) + (this.j9l_1 == null ? 0 : getStringHashCode(this.j9l_1)) | 0;
    result = imul(result, 31) + (this.k9l_1 == null ? 0 : getBooleanHashCode(this.k9l_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l9l_1) | 0;
    result = imul(result, 31) + this.m9l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n9l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p9l_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.q9l_1) | 0;
    result = imul(result, 31) + hashCode(this.r9l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s9l_1) | 0;
    result = imul(result, 31) + (this.t9l_1 == null ? 0 : getBooleanHashCode(this.t9l_1)) | 0;
    result = imul(result, 31) + (this.u9l_1 == null ? 0 : getBooleanHashCode(this.u9l_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.o9k_1, tmp0_other_with_cast.o9k_1))
      return false;
    if (!equals(this.p9k_1, tmp0_other_with_cast.p9k_1))
      return false;
    if (!equals(this.q9k_1, tmp0_other_with_cast.q9k_1))
      return false;
    if (!equals(this.r9k_1, tmp0_other_with_cast.r9k_1))
      return false;
    if (!equals(this.s9k_1, tmp0_other_with_cast.s9k_1))
      return false;
    if (!equals(this.t9k_1, tmp0_other_with_cast.t9k_1))
      return false;
    if (!equals(this.u9k_1, tmp0_other_with_cast.u9k_1))
      return false;
    if (!(this.v9k_1 === tmp0_other_with_cast.v9k_1))
      return false;
    if (!(this.w9k_1 === tmp0_other_with_cast.w9k_1))
      return false;
    if (!equals(this.x9k_1, tmp0_other_with_cast.x9k_1))
      return false;
    if (!(this.y9k_1 == tmp0_other_with_cast.y9k_1))
      return false;
    if (!(this.z9k_1 === tmp0_other_with_cast.z9k_1))
      return false;
    if (!(this.a9l_1 === tmp0_other_with_cast.a9l_1))
      return false;
    if (!(this.b9l_1 == tmp0_other_with_cast.b9l_1))
      return false;
    if (!(this.c9l_1 === tmp0_other_with_cast.c9l_1))
      return false;
    if (!this.d9l_1.equals(tmp0_other_with_cast.d9l_1))
      return false;
    if (!this.e9l_1.equals(tmp0_other_with_cast.e9l_1))
      return false;
    if (!this.f9l_1.equals(tmp0_other_with_cast.f9l_1))
      return false;
    if (!(this.g9l_1 === tmp0_other_with_cast.g9l_1))
      return false;
    var tmp = this.h9l_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.h9l_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.i9l_1.equals(tmp0_other_with_cast.i9l_1))
      return false;
    if (!(this.j9l_1 == tmp0_other_with_cast.j9l_1))
      return false;
    if (!(this.k9l_1 == tmp0_other_with_cast.k9l_1))
      return false;
    if (!(this.l9l_1 === tmp0_other_with_cast.l9l_1))
      return false;
    if (!this.m9l_1.equals(tmp0_other_with_cast.m9l_1))
      return false;
    if (!equals(this.n9l_1, tmp0_other_with_cast.n9l_1))
      return false;
    if (!(this.o9l_1 === tmp0_other_with_cast.o9l_1))
      return false;
    if (!equals(this.p9l_1, tmp0_other_with_cast.p9l_1))
      return false;
    if (!(this.q9l_1 === tmp0_other_with_cast.q9l_1))
      return false;
    if (!equals(this.r9l_1, tmp0_other_with_cast.r9l_1))
      return false;
    if (!equals(this.s9l_1, tmp0_other_with_cast.s9l_1))
      return false;
    if (!(this.t9l_1 == tmp0_other_with_cast.t9l_1))
      return false;
    if (!(this.u9l_1 == tmp0_other_with_cast.u9l_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.r9o_1 = new KorgeDisplayMode(Companion_getInstance_24().d2j_1, Companion_getInstance_25().k28(), true);
    this.s9o_1 = new KorgeDisplayMode(Companion_getInstance_24().d2j_1, Companion_getInstance_25().k28(), false);
    this.t9o_1 = new KorgeDisplayMode(Companion_getInstance_24().d2j_1, Companion_getInstance_25().y27_1, false);
    this.u9o_1 = new KorgeDisplayMode(Companion_getInstance_24().f2j_1, Companion_getInstance_25().y27_1, false);
  }
  h3q() {
    return this.r9o_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_37();
    this.x9o_1 = scaleMode;
    this.y9o_1 = scaleAnchor;
    this.z9o_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.x9o_1.toString() + ', scaleAnchor=' + this.y9o_1.toString() + ', clipBorders=' + this.z9o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x9o_1);
    result = imul(result, 31) + this.y9o_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.x9o_1, tmp0_other_with_cast.x9o_1))
      return false;
    if (!this.y9o_1.equals(tmp0_other_with_cast.y9o_1))
      return false;
    if (!(this.z9o_1 === tmp0_other_with_cast.z9o_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.o9r_1 = $config;
    this.p9r_1 = $views;
    this.q9r_1 = $entry;
    this.r9r_1 = $gameWindow;
  }
  h1p($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.u9w_1 = $config;
    this.v9w_1 = $views;
    this.w9w_1 = $entry;
    this.x9w_1 = $gameWindow;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.y9w_1 = $realGameWindow;
    this.z9w_1 = $windowSize;
    this.a9x_1 = $config;
    this.b9x_1 = $iconPath;
    this.c9x_1 = $imageFormats;
    this.d9x_1 = $entry;
  }
  l9x($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  wd(p1, $completion) {
    return this.l9x(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.m9x_1 = $views;
  }
  vd($completion) {
    this.m9x_1.g6();
  }
}
class KorgeRunner {
  x9l(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  h9x(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.h9p_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.a6b(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.g9p_1;
    injector.a6b(getKClass(AG), instance);
    injector.a6b(getKClass(Resources), views.o9x());
    var tmp = getKClass(ResourcesRoot);
    injector.d6b(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.i9p_1;
    injector.a6b(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.k9p_1;
    injector.a6b(getKClass(Stats), instance_1);
    injector.a6b(getKClass(CoroutineContext), views.f9p_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.e6b(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.a6b(getKClass(TimeProvider), views.j9p_1);
    configInjector(injector);
    var input = views.i9p_1;
    var ag = views.g9p_1;
    var downPos = {_v: Companion_getInstance_27().z28_1};
    var upPos = {_v: Companion_getInstance_27().z28_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().l1w_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().l1w_1)};
    var upTime = Companion_getInstance_5().l1w_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.p9x(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().w6f_1.slice();
    eventDispatcher.h6e(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().i6f_1.slice();
    eventDispatcher.h6e(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().x6g_1.slice();
    eventDispatcher.h6e(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().e6h_1.slice();
    eventDispatcher.h6e(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.v6d(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.v6d(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.v6d(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.v6d(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().z6h_1.slice();
    eventDispatcher.h6e(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().e6k_1.slice();
    eventDispatcher.h6e(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.v6d(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.v6d(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.g6e(new ReshapeEvent(0, 0, views.q9x(), views.r9x()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.v6d(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.f9q_1 = clearEachFrame;
    views.g9q_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.l9p_1.x8o(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  a9m(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  wd(p1, $completion) {
    return this.a9m(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  a9m(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  wd(p1, $completion) {
    return this.a9m(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.y9x_1 = this$0;
    this.z9x_1 = $event;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.a9y_1 = this$0;
    this.b9y_1 = $event;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.c9y_1 = this$0;
    this.d9y_1 = $event;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.s9x_1 = view;
    this.u9x_1 = new AsyncSignal();
    this.v9x_1 = new AsyncSignal();
    this.w9x_1 = new AsyncSignal();
    this.x9x_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.s9x_1.v6d(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.s9x_1.v6d(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.s9x_1.v6d(tmp_1, KeysEvents$lambda_1(this));
  }
  f9y() {
    var tmp = this.t9x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  g9y(_this__u8e3s4, key, keys, dt, type) {
    _this__u8e3s4.l6f_1 = type;
    _this__u8e3s4.n6f_1 = key;
    _this__u8e3s4.o6f_1 = key.k3_1;
    _this__u8e3s4.q6f_1 = keys.b89_1;
    _this__u8e3s4.r6f_1 = keys.c89_1;
    _this__u8e3s4.s6f_1 = keys.d89_1;
    _this__u8e3s4.t6f_1 = keys.e89_1;
    _this__u8e3s4.v6f_1 = dt;
    return _this__u8e3s4;
  }
  e9y(_this__u8e3s4, key, keys, dt, type, $super) {
    type = type === VOID ? Type_DOWN_getInstance_0() : type;
    return $super === VOID ? this.g9y(_this__u8e3s4, key, keys, dt, type) : $super.g9y.call(this, _this__u8e3s4, key, keys, new Duration(dt), type);
  }
  h9y(keys, callback) {
    var ke = new KeyEvent();
    return addUpdaterWithViews(this.s9x_1, KeysEvents$justDown$lambda(keys, callback, this, ke));
  }
  i9y(key, callback) {
    return this.h9y(listOf(key), callback);
  }
  g6() {
    this.x9x_1.g6();
  }
}
class Companion_1 {
  fa0(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.a38_1) {
      this_0.a38_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.x9q_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.ia0_1 = $outer;
    this.ga0_1 = new Mixin();
    this.ha0_1 = view;
    addUpdaterWithViews(this.ha0_1, MouseEvents$MouseEventsUpdate$lambda(this.ia0_1));
  }
  cz(value) {
    this.ga0_1.cz(value);
  }
  dz() {
    return this.ga0_1.dz();
  }
}
class MouseEvents {
  constructor(view) {
    this.p9y_1 = new Mixin();
    this.q9y_1 = view;
    this.q9y_1.ma0(true);
    this.s9y_1 = new Signal();
    this.t9y_1 = new Signal();
    this.u9y_1 = new Signal();
    this.v9y_1 = new Signal();
    this.w9y_1 = new Signal();
    this.x9y_1 = new Signal();
    this.y9y_1 = new Signal();
    this.z9y_1 = new Signal();
    this.a9z_1 = new Signal();
    this.b9z_1 = new Signal();
    this.c9z_1 = new Signal();
    this.d9z_1 = new Signal();
    this.e9z_1 = new Signal();
    this.f9z_1 = new Signal();
    this.g9z_1 = new Signal();
    this.h9z_1 = new Signal();
    this.i9z_1 = new Signal();
    this.j9z_1 = new Signal();
    this.k9z_1 = new Signal();
    this.l9z_1 = null;
    this.m9z_1 = false;
    this.n9z_1 = false;
    this.o9z_1 = false;
    this.p9z_1 = PerformanceCounter_getInstance().v6b();
    this.q9z_1 = PerformanceCounter_getInstance().v6b();
    this.r9z_1 = Vector2D.o2b();
    this.s9z_1 = Vector2D.o2b();
    this.t9z_1 = Vector2D.o2b();
    this.u9z_1 = Vector2D.o2b();
    this.v9z_1 = Vector2D.o2b();
    this.w9z_1 = 0;
    this.x9z_1 = false;
    this.y9z_1 = null;
    this.z9z_1 = new MouseEvent();
    this.aa0_1 = false;
    this.ba0_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().w6f_1.slice();
    tmp.ca0_1 = this.q9y_1.h6e(tmp_0, MouseEvents$closeable$lambda(this));
    this.da0_1 = new MouseEventsUpdate(this, this.q9y_1);
  }
  ka0() {
    var tmp = this.r9y_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  la0() {
    var tmp0_safe_receiver = this.l9z_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.q9y_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  na0() {
    return !(this.ka0().i9p_1.v89_1 === 0);
  }
  toString() {
    return this.z9z_1.toString();
  }
  ea0(views, dt) {
    if (!this.q9y_1.ja0())
      return Unit_instance;
    this.r9y_1 = views;
    Companion_instance_16.fa0(views);
    this.l9z_1 = mouseHitTest(Companion_instance_16, views);
    var over = this.la0();
    var inside = views.i9p_1.x89_1;
    if (over) {
      set_mouseHitResultUsed(views.i9p_1, this.q9y_1);
    }
    var overChanged = !(this.m9z_1 === over);
    var insideChanged = !(this.n9z_1 === inside);
    var pressingChanged = !(this.na0() === this.o9z_1);
    this.v9z_1 = views.i9p_1.l8a();
    if (!overChanged && over && !this.v9z_1.equals(this.u9z_1)) {
      this.e9z_1.u1z(this);
    }
    if (!overChanged && !over && !this.v9z_1.equals(this.u9z_1)) {
      this.g9z_1.u1z(this);
    }
    if (!this.v9z_1.equals(this.u9z_1)) {
      this.f9z_1.u1z(this);
    }
    if (overChanged && over) {
      this.u9y_1.u1z(this);
    }
    if (overChanged && !over) {
      this.v9y_1.u1z(this);
    }
    if (pressingChanged && this.na0()) {
      this.t9z_1 = this.v9z_1;
      if (over) {
        this.w9y_1.u1z(this);
      }
      if (!over) {
        this.x9y_1.u1z(this);
      }
    }
    if (overChanged && this.na0()) {
      this.y9y_1.u1z(this);
    }
    if (pressingChanged && !this.na0()) {
      var tmp = this.ba0_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.w9z_1 > 0;
    if (insideChanged && !inside) {
      this.g9z_1.u1z(this);
      this.v9y_1.u1z(this);
      this.b9z_1.u1z(this);
      this.c9z_1.u1z(this);
      this.h9z_1.u1z(this);
    }
    this.m9z_1 = over;
    this.n9z_1 = inside;
    this.o9z_1 = this.na0();
    this.u9z_1 = this.v9z_1;
    this.w9z_1 = 0;
  }
  g6() {
    this.ca0_1.g6();
  }
  cz(value) {
    this.p9y_1.cz(value);
  }
  dz() {
    return this.p9y_1.dz();
  }
}
class SceneCancellationException extends CancellationException {
  static ua0(scene) {
    var $this = this.nd('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.ta0_1);
    $this.sa0_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.va0_1 = new Mixin();
    this.aa1_1 = Container.sa3();
    this.ba1_1 = new CancellableGroup();
    var tmp = this;
    tmp.ca1_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.da1_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.ea1_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  ga1() {
    var tmp = this.wa0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  ta3(_set____db54di) {
    this.xa0_1 = _set____db54di;
  }
  ka0() {
    var tmp = this.xa0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ha1() {
    var tmp = this.ya0_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  b16() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ca1_1;
    coroutineContext$factory();
    return this_0.n1();
  }
  ua3() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.da1_1;
    sceneView$factory();
    return this_0.n1();
  }
  ia1(size) {
    return SContainer.ga6(size);
  }
  l6b(injector) {
    this.wa0_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.j6b(getKClass(Views));
    this.ta3(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.ya0_1 = injector.j6b(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.za0_1 = injector.j6b(getKClass(ResourcesRoot));
  }
  ha6(_this__u8e3s4, $completion) {
  }
  ia6(_this__u8e3s4, $completion) {
  }
  ja6($completion) {
  }
  ka6($completion) {
  }
  la6($completion) {
  }
  ma6() {
    cancel_0(this.ba1_1);
    this.ga1().m6b();
  }
  fa1($completion) {
  }
  na6($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  cz(value) {
    this.va0_1.cz(value);
  }
  dz() {
    return this.va0_1.dz();
  }
}
class EmptyScene extends Scene {
  ia6(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.eaa_1 = clazz;
    this.faa_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.eaa_1) + ', injects=' + toString(this.faa_1) + ')';
  }
  hashCode() {
    var result = this.eaa_1.hashCode();
    result = imul(result, 31) + hashCode(this.faa_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.eaa_1.equals(tmp0_other_with_cast.eaa_1))
      return false;
    if (!equals(this.faa_1, tmp0_other_with_cast.faa_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.ia7_1 = Companion_getInstance_0().tx('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.ja7_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.ya6_1 = this$0;
    this.za6_1 = $event;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.la7_1 = $newScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.ma7_1 = $newScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.na7_1 = $oldScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.oa7_1 = $oldScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.pa7_1 = $oldScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.qa7_1 = $newScene;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static vaw() {
    return this.t6d();
  }
  zaf() {
  }
}
class View extends BaseView {
  static paz(isContainer) {
    var $this = this.vaw();
    $this.w9r_1 = isContainer;
    var tmp = $this;
    tmp.x9r_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.y9r_1 = true;
    $this.z9r_1 = null;
    $this.a9s_1 = null;
    $this.b9s_1 = null;
    $this.c9s_1 = 0;
    $this.d9s_1 = null;
    $this.e9s_1 = 1.0;
    $this.f9s_1 = null;
    $this.g9s_1 = null;
    $this.h9s_1 = null;
    $this.i9s_1 = Companion_getInstance_13().l85_1;
    $this.j9s_1 = 0.0;
    $this.k9s_1 = 0.0;
    $this.l9s_1 = 1.0;
    $this.m9s_1 = 1.0;
    $this.n9s_1 = Companion_getInstance_31().o28_1;
    $this.o9s_1 = Companion_getInstance_31().o28_1;
    $this.p9s_1 = Companion_getInstance_31().o28_1;
    $this.q9s_1 = 0.0;
    $this.r9s_1 = scale$factory($this);
    $this.s9s_1 = false;
    $this.t9s_1 = true;
    $this.u9s_1 = true;
    $this.v9s_1 = true;
    $this.w9s_1 = true;
    $this.x9s_1 = Companion_getInstance_30().f2c_1;
    $this.y9s_1 = Companion_getInstance_30().f2c_1;
    $this.z9s_1 = -1;
    $this.a9t_1 = Companion_getInstance_30().f2c_1;
    $this.b9t_1 = -1;
    $this.c9t_1 = new ColorTransformMul();
    $this.d9t_1 = new ColorTransformMul();
    $this.e9t_1 = -1;
    $this.f9t_1 = Companion_getInstance_13().l85_1;
    $this.g9t_1 = -1;
    $this.h9t_1 = true;
    $this.i9t_1 = 0;
    $this.j9t_1 = 0;
    $this.k9t_1 = false;
    $this.l9t_1 = false;
    $this.m9t_1 = null;
    $this.n9t_1 = false;
    $this.o9t_1 = null;
    $this.p9t_1 = 0;
    $this.q9t_1 = true;
    $this.r9t_1 = null;
    return $this;
  }
  uag() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x9r_1;
    bviewAll$factory();
    return this_0.n1();
  }
  static ib5() {
    return this.paz(false);
  }
  vag() {
    return 0.0;
  }
  wag() {
    return 0.0;
  }
  cag() {
    return null;
  }
  uaw(_set____db54di) {
    this.a9s_1 = _set____db54di;
  }
  xag() {
    return this.a9s_1;
  }
  yag() {
    return this.b9s_1;
  }
  zag(value) {
    this.c9s_1 = value;
  }
  p6k() {
    return this.c9s_1;
  }
  aah(value) {
    if (this.f9s_1 === value)
      return Unit_instance;
    this.f9s_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.cag();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).aah(value);
      }
      tmp = Unit_instance;
    }
    this.bah();
  }
  bah() {
  }
  cah(value) {
    if (this.g9s_1 === value)
      return Unit_instance;
    this.g9s_1 = value;
    var parent = this.aag();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.cag();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).cah(parent);
      }
      tmp = Unit_instance;
    }
  }
  aag() {
    return this.g9s_1;
  }
  dah() {
    var tmp0_safe_receiver = this.d9s_1;
    this.cah(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.aag());
  }
  eah(value) {
    if (this.d9s_1 === value)
      return Unit_instance;
    this.d9s_1 = value;
    var tmp0_safe_receiver = this.d9s_1;
    this.aah(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f9s_1);
    this.dah();
    this.lai();
    this.u6d(value);
  }
  h27() {
    return this.d9s_1;
  }
  fah() {
    return !(this.h27() == null) ? ensureNotNull(this.h27()).fah() * this.e9s_1 : this.e9s_1;
  }
  gah(x, y) {
    this.aai();
    if (!(this.j9s_1 === x) || !(this.k9s_1 === y)) {
      this.j9s_1 = x;
      this.k9s_1 = y;
      this.jai();
    }
  }
  s4r(value) {
    return this.gah(value.x28_1, value.y28_1);
  }
  ay() {
    return Vector2D.d2b(this.w6h(), this.x6h());
  }
  hah(v) {
    this.gah(v, this.x6h());
  }
  w6h() {
    this.aai();
    return this.j9s_1;
  }
  iah(v) {
    this.gah(this.w6h(), v);
  }
  x6h() {
    this.aai();
    return this.k9s_1;
  }
  jah() {
    return this.q9s_1;
  }
  kah(v) {
    this.qah(Scale.o2g(v, v));
  }
  lah() {
    return this.rah().q2e();
  }
  mah(v) {
    this.aai();
    if (!(this.l9s_1 === v)) {
      this.l9s_1 = v;
      this.jai();
    }
  }
  nah() {
    this.aai();
    return this.l9s_1;
  }
  oah(v) {
    this.aai();
    if (!(this.m9s_1 === v)) {
      this.m9s_1 = v;
      this.jai();
    }
  }
  pah() {
    this.aai();
    return this.m9s_1;
  }
  qah(value) {
    this.mah(value.m2g_1);
    this.oah(value.n2g_1);
  }
  rah() {
    return Scale.o2g(this.nah(), this.pah());
  }
  sah() {
    this.aai();
    return this.n9s_1;
  }
  tah() {
    this.aai();
    return this.o9s_1;
  }
  nbe(v) {
    this.aai();
    if (!equals(this.p9s_1, v)) {
      this.p9s_1 = v;
      this.jai();
    }
  }
  uah() {
    this.aai();
    return this.p9s_1;
  }
  vah() {
    var tmp0_safe_receiver = this.h27();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sai(Vector2D.d2b(this.w6h(), this.x6h()));
    return tmp1_elvis_lhs == null ? Vector2D.d2b(this.w6h(), this.x6h()) : tmp1_elvis_lhs;
  }
  e1() {
    return this.ead();
  }
  ead() {
    return this.l9y().e1();
  }
  wah() {
    return this.ead().c2a_1;
  }
  xah() {
    return this.ead().d2a_1;
  }
  pbe() {
    return this.wah() * this.nah();
  }
  qbe() {
    return this.xah() * this.pah();
  }
  k2l() {
    return this.wah();
  }
  l2l() {
    return this.xah();
  }
  t4e(v) {
    if (!(v === this.c9t_1.v4e())) {
      this.c9t_1.t4e(v);
      this.eag();
    }
  }
  v4e() {
    return this.c9t_1.v4e();
  }
  rbe(v) {
    this.yah(v);
  }
  yah(v) {
    if (!(this.c9t_1.s4e() === v)) {
      this.c9t_1.r4e(v);
      this.eag();
    }
  }
  zah() {
    return this.c9t_1.s4e();
  }
  aai() {
    if (this.v9s_1)
      return Unit_instance;
    this.v9s_1 = true;
    var t = this.x9s_1.s2d();
    this.j9s_1 = t.e2e_1;
    this.k9s_1 = t.f2e_1;
    this.l9s_1 = t.g2e_1;
    this.m9s_1 = t.h2e_1;
    this.n9s_1 = t.i2e_1;
    this.o9s_1 = t.j2e_1;
    this.p9s_1 = t.k2e_1;
  }
  b27() {
    var tmp0_safe_receiver = this.h27();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b27();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  bai() {
    return this.f9s_1;
  }
  ma0(_set____db54di) {
    this.s9s_1 = _set____db54di;
  }
  ja0() {
    return this.s9s_1;
  }
  cai() {
    return this.t9s_1;
  }
  e8p(value) {
    if (!(this.u9s_1 === value)) {
      this.u9s_1 = value;
      this.dag();
    }
  }
  dai() {
    return this.u9s_1;
  }
  eai() {
    if (!this.w9s_1) {
      this.w9s_1 = true;
      this.k9t_1 = true;
      this.x9s_1 = Companion_getInstance_30().r2c(this.w6h(), this.x6h(), this.uah(), this.nah(), this.pah(), this.sah(), this.tah(), 0.0, 0.0);
    }
    return this.x9s_1;
  }
  n9y() {
    if (!(this.z9s_1 === this.i9t_1)) {
      this.z9s_1 = this.i9t_1;
      this.k9t_1 = true;
      this.y9s_1 = !(this.h27() == null) ? this.eai().t2c(ensureNotNull(this.h27()).n9y()) : this.eai();
    }
    return this.y9s_1;
  }
  fai() {
    if (!(this.b9t_1 === this.i9t_1)) {
      this.b9t_1 = this.i9t_1;
      this.k9t_1 = true;
      this.a9t_1 = this.n9y().r2d();
    }
    return this.a9t_1;
  }
  gai() {
    updateRenderColorTransformIfRequired(this);
    return this.d9t_1;
  }
  hai() {
    updateRenderBlendModeIfRequired(this);
    return this.f9t_1;
  }
  iai() {
    updateRenderColorTransformIfRequired(this);
    return this.d9t_1.v4e();
  }
  saz(views) {
    return this.rai(views.i9p_1.l8a());
  }
  jai() {
    this.w9s_1 = false;
    this.dag();
  }
  dag() {
    this.i9t_1 = this.i9t_1 + 1 | 0;
    this.k9t_1 = false;
    this.h9t_1 = true;
    this.zaf();
  }
  kai() {
    if (!(this.m9t_1 == null)) {
      this.m9t_1 = null;
      var tmp0_safe_receiver = this.h27();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.kai();
      }
    }
  }
  lai() {
    this.had();
  }
  mai() {
    this.had();
  }
  had() {
  }
  zaf() {
    var tmp0_safe_receiver = this.g9s_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.bag(this);
    }
    this.kai();
  }
  eag() {
    this.j9t_1 = this.j9t_1 + 1 | 0;
    this.l9t_1 = false;
    this.h9t_1 = true;
    this.zaf();
  }
  fad(ctx) {
    if (!this.dai())
      return Unit_instance;
    var tmp0_safe_receiver = this.o9t_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].fbx(this, ctx);
      }
    }
    try {
      this.nai(ctx);
    }finally {
      var tmp1_safe_receiver = this.o9t_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.sz_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.e1() - n_0 | 0) - 1 | 0].gbx(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  nai(ctx) {
    var oldPhase = this.p9t_1;
    try {
      this.p9t_1 = 0;
      this.oai(ctx);
    }finally {
      this.p9t_1 = oldPhase;
    }
  }
  oai(ctx) {
    var stages = this.o9t_1;
    if (!(stages == null) && this.p9t_1 < stages.e1()) {
      var _unary__edvuaz = this.p9t_1;
      this.p9t_1 = _unary__edvuaz + 1 | 0;
      stages.d1(_unary__edvuaz).hbx(this, ctx);
    } else {
      var tmp = this.p9t_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.e1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.jad(ctx);
        this.p9t_1 = this.p9t_1 + 1 | 0;
      }
    }
  }
  nag(ctx) {
    if (this.n9t_1 || this === get_debugAnnotateView(ctx)) {
      this.pai(ctx);
    }
  }
  pai(ctx) {
    var local = this.l9y();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.f8g_1;
    if (!(this_1.h87_1 === this_0)) {
      this_1.h87_1 = this_0;
      this_1.r88();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_2(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.r8g_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().u85_1;
          var doUpdate = !(this_0.q8g_1 === blending);
          var old = this_0.q8g_1;
          try {
            if (doUpdate) {
              this_0.f8g_1.r88();
              this_0.q8g_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().j3z_1;
            var m = this_0.r8g_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.i8g_1;
            this_0.i8g_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.w3p(this.daj());
              this_0.y8g(this_3, m);
            }finally {
              this_0.i8g_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.f8g_1.r88();
            }
            this_0.q8g_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().j3z_1;
        var m_0 = this_0.r8g_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.i8g_1;
        this_0.i8g_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.q3g(this.sai(Vector2D.d2b(local.o29(), local.q29())));
          this_4.s3g(this.sai(Vector2D.d2b(local.p29(), local.q29())));
          this_4.s3g(this.sai(Vector2D.d2b(local.p29(), local.r29())));
          this_4.s3g(this.sai(Vector2D.d2b(local.o29(), local.r29())));
          this_4.g6();
          this_0.y8g(this_4, m_0);
        }finally {
          this_0.i8g_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().x44_1;
        var m_1 = this_0.r8g_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.i8g_1;
        this_0.i8g_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).y8f();
          this_5.c3q(this.sai(local.g2a()), anchorSize);
          this_5.c3q(this.sai(local.n2h()), anchorSize);
          this_5.c3q(this.sai(local.i2a()), anchorSize);
          this_5.c3q(this.sai(local.o2h()), anchorSize);
          this_5.c3q(this.sai(interpolate(Companion_getInstance_34().ty_1, local.g2a(), local.n2h())), anchorSize);
          this_5.c3q(this.sai(interpolate(Companion_getInstance_34().ty_1, local.n2h(), local.i2a())), anchorSize);
          this_5.c3q(this.sai(interpolate(Companion_getInstance_34().ty_1, local.i2a(), local.o2h())), anchorSize);
          this_5.c3q(this.sai(interpolate(Companion_getInstance_34().ty_1, local.o2h(), local.g2a())), anchorSize);
          this_0.y8g(this_5, m_1);
        }finally {
          this_0.i8g_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().l3z_1;
        var m_2 = this_0.r8g_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.i8g_1;
        this_0.i8g_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.vah();
          this_6.u3p(Vector2D.d2b(center.x28_1, center.y28_1 - 5), Vector2D.d2b(center.x28_1, center.y28_1 + 5));
          this_6.u3p(Vector2D.d2b(center.x28_1 - 5, center.y28_1), Vector2D.d2b(center.x28_1 + 5, center.y28_1));
          this_0.y8g(this_6, m_2);
        }finally {
          this_0.i8g_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.w6h() === 0.0) || !(this.x6h() === 0.0))
      out = out + (':pos=(' + this.qai(this.w6h()) + ',' + this.qai(this.x6h()) + ')');
    if (!(this.nah() === 1.0) || !(this.pah() === 1.0))
      out = out + (':scale=(' + this.qai(this.nah()) + ',' + this.qai(this.pah()) + ')');
    if (!equals(this.sah(), Companion_getInstance_31().o28_1) || !equals(this.tah(), Companion_getInstance_31().o28_1))
      out = out + (':skew=(' + this.qai(_Angle___get_degrees__impl__qg56vw(this.sah())) + ',' + this.qai(_Angle___get_degrees__impl__qg56vw(this.tah())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.uah()), Companion_getInstance_31().o28_1))
      out = out + (':rotation=(' + this.qai(_Angle___get_degrees__impl__qg56vw(this.uah())) + '\xBA)');
    if (!(this.h9s_1 == null))
      out = out + (':name=(' + this.h9s_1 + ')');
    if (!this.i9s_1.equals(Companion_getInstance_13().l85_1))
      out = out + (':blendMode=(' + this.i9s_1.toString() + ')');
    if (!this.dai())
      out = out + (':visible=' + this.dai());
    if (!(this.zah() === 1.0))
      out = out + (':alpha=' + niceStr(this.zah(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.v4e()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().h3z_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.v4e()));
    return out;
  }
  qai(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  rai(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.fai();
      if (this_0.m29()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.d2b(this_0.x2c(p.x28_1, p.y28_1), this_0.a2d(p.x28_1, p.y28_1));
    }
    return tmp$ret$0;
  }
  sai(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.n9y();
      if (this_0.m29()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.d2b(this_0.x2c(p.x28_1, p.y28_1), this_0.a2d(p.x28_1, p.y28_1));
    }
    return tmp$ret$0;
  }
  k9y(p) {
    if (!this.q9t_1)
      return null;
    if (!this.dai())
      return null;
    if (this.cai()) {
      var tmp0_safe_receiver = this.cag();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.d1((tmp0_safe_receiver.e1() - n | 0) - 1 | 0).k9y(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.ja0())
      return null;
    var tmp1_safe_receiver = this.vai(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.tai();
      if (!area.m29() && !area.l2h(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  tai() {
    var out = Companion_getInstance_28().u29_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h27();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.w5n();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.faj();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.v2h(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.h27();
    }
    return count === 0 ? Companion_getInstance_28().w29() : out;
  }
  uai(p, direction) {
    if (!this.q9t_1)
      return null;
    var ll = this.rai(p);
    var bounds = this.l9y();
    if (!bounds.l2h(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.o2d(this.vag(), this.wag());
    var l = Vector2D.d2b(ll.x28_1 + that.x28_1, ll.y28_1 + that.y28_1);
    if (this.r9t_1 === false)
      return this;
    var hitShape = this.xag();
    var hitShapes = this.yag();
    if (this.r9t_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.e1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.d1(_unary__edvuaz).k3q(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.k3q(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  vai(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.uai(p, direction) : $super.uai.call(this, p, direction);
  }
  wai() {
    var tmp0_safe_receiver = this.h27();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.tag(this);
  }
  xai(target, inclusive) {
    var tmp;
    if (target === this.h27()) {
      tmp = this.eai();
    } else if (target === this) {
      tmp = Companion_getInstance_30().f2c_1;
    } else {
      var commonAncestor = Companion_instance_25.ebx(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.h27() == null && inclusive) {
          return this.n9y();
        }
        tmp_0 = this.n9y().t2c(target.fai());
      } else {
        tmp_0 = Companion_getInstance_30().f2c_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.t2c(target.eai());
    }
    return out;
  }
  yai() {
    var tmp0_elvis_lhs = this.zai();
    return tmp0_elvis_lhs == null ? this.faj() : tmp0_elvis_lhs;
  }
  zai() {
    var stage = this.b27();
    if (!(stage instanceof Stage))
      return null;
    return this.aaj(stage);
  }
  aaj(bp) {
    return this.faj().d2i(bp.u8f());
  }
  baj(ctx) {
    return ctx.g8h() ? this.aaj(ctx) : this.faj();
  }
  caj(ctx) {
    return this.baj(ctx);
  }
  daj() {
    return this.faj();
  }
  eaj(includeFilters) {
    return this.iaj(this.b27(), VOID, true, includeFilters);
  }
  faj(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.eaj(includeFilters) : $super.eaj.call(this, includeFilters);
  }
  gaj(concat, doAnchoring, includeFilters) {
    var out = this.jaj(doAnchoring, includeFilters);
    if (concat.n29() && !concat.u2c()) {
      var tmp = Companion_getInstance_29();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.g2a();
        if (concat.m29()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.d2b(concat.x2c(p.x28_1, p.y28_1), concat.a2d(p.x28_1, p.y28_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.n2h();
        if (concat.m29()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.d2b(concat.x2c(p_0.x28_1, p_0.y28_1), concat.a2d(p_0.x28_1, p_0.y28_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.i2a();
        if (concat.m29()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.d2b(concat.x2c(p_1.x28_1, p_1.y28_1), concat.a2d(p_1.x28_1, p_1.y28_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.o2h();
        if (concat.m29()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.d2b(concat.x2c(p_2.x28_1, p_2.y28_1), concat.a2d(p_2.x28_1, p_2.y28_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.y29(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  haj(target, doAnchoring, inclusive, includeFilters) {
    return this.gaj(this.xai(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  iaj(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.haj(target, doAnchoring, inclusive, includeFilters) : $super.haj.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  jaj(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.m9t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.gad();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.m9t_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.j2d(Vector2D.o2d(this.vag(), this.wag()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  l9y(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.jaj(doAnchoring, includeFilters) : $super.jaj.call(this, doAnchoring, includeFilters);
  }
  gad() {
    return Companion_getInstance_28().w29();
  }
  c6e(type, event, result) {
    var tmp0_safe_receiver = this.h27();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.j6e(type, event, result);
  }
}
class Container extends View {
  static sa3(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.paz(true);
    $this.ja3_1 = cull;
    $this.ka3_1 = FastArrayList.uz();
    $this.la3_1 = new ContainerCollection($this, $this.ka3_1);
    $this.ma3_1 = null;
    $this.na3_1 = new MMatrix();
    $this.oa3_1 = false;
    $this.pa3_1 = false;
    $this.qa3_1 = FastArrayList.uz();
    return $this;
  }
  cag() {
    return this.ka3_1;
  }
  dag() {
    super.dag();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.la3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.k9t_1) {
        child.dag();
      }
    }
  }
  eag() {
    super.eag();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.la3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      if (child.l9t_1) {
        child.eag();
      }
    }
  }
  fag() {
    return this.ka3_1.e1();
  }
  gag(view) {
  }
  had() {
    super.had();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.cag();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.d1(_unary__edvuaz).mai();
      }
      tmp = Unit_instance;
    }
  }
  hag(index) {
    return this.ka3_1.d1(index);
  }
  iag(index) {
    return this.jag(index, 1) === 1;
  }
  jag(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.fag();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.hag(removedIndex);
        view.eah(null);
        view.zag(-1);
      }
       while (inductionVariable < to);
    this.ka3_1.xz(from, to);
    var inductionVariable_0 = index;
    var last = this.fag();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.ka3_1.d1(i).zag(i);
      }
       while (inductionVariable_0 < last);
    this.pag();
    this.qag();
    this.kai();
    return to - from | 0;
  }
  kag() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.la3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      child.eah(null);
      child.zag(-1);
    }
    this.ka3_1.e3();
    this.pag();
  }
  lag(view) {
    return this.sag(view, this.fag());
  }
  ra3(view) {
    this.sag(view, this.fag());
  }
  d1(index) {
    return this.hag(index);
  }
  jad(ctx) {
    if (!this.dai())
      return Unit_instance;
    this.mag(ctx);
  }
  mag(ctx) {
    if (!this.ja3_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.oa3_1) {
        this.oa3_1 = true;
        this.qa3_1.e3();
        this.qa3_1.f1(this.la3_1);
        if (this.oag())
          this.pa3_1 = false;
      }
      if (!this.pa3_1) {
        this.pa3_1 = true;
        sortWith(this.qa3_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.qa3_1.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].fad(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.faj();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_28().w29() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.oa3_1) {
      this.oa3_1 = true;
      this.qa3_1.e3();
      this.qa3_1.f1(this.la3_1);
      if (this.oag())
        this.pa3_1 = false;
    }
    if (!this.pa3_1) {
      this.pa3_1 = true;
      sortWith(this.qa3_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.qa3_1.sz_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.m29() || bounds.s2h(child.eaj(true))) {
        child.fad(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  nag(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.oa3_1) {
      this.oa3_1 = true;
      this.qa3_1.e3();
      this.qa3_1.f1(this.la3_1);
      if (this.oag())
        this.pa3_1 = false;
    }
    if (!this.pa3_1) {
      this.pa3_1 = true;
      sortWith(this.qa3_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.qa3_1.sz_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].nag(ctx);
    }
    super.nag(ctx);
  }
  gad() {
    var bb = Companion_getInstance_29().x29();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.la3_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.iaj(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  oag() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ka3_1.sz_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].jah() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  pag() {
    this.oa3_1 = false;
    this.qag();
  }
  qag() {
    var tmp0_safe_receiver = this.bai();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ka0();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.bag(this);
    }
  }
  rag(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  sag(view, index) {
    this.rag(view);
    var tmp0_safe_receiver = view.h27();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pag();
    }
    view.wai();
    var aindex = clamp_1(index, 0, this.fag());
    var children = this.ka3_1;
    children.b7(aindex, view);
    var inductionVariable = aindex;
    var last = this.fag();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.d1(n).zag(n);
      }
       while (inductionVariable < last);
    view.eah(this);
    view.dag();
    this.gag(view);
    this.pag();
    this.qag();
    this.kai();
  }
  tag(view) {
    if (!((view == null ? null : view.h27()) === this))
      return false;
    return this.iag(view.p6k());
  }
  z6d(type, event, result) {
    if (this.ma3_1 == null)
      this.ma3_1 = FastArrayList.tz(this.la3_1.e1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.ka3_1;
    var temp = ensureNotNull(this.ma3_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].i6e(type, event, result);
      }
    }finally {
      temp.e3();
    }
  }
}
class CachedContainer extends Container {
  static waw(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.sa3();
    $this.saf_1 = cache;
    $this.taf_1 = renderQuality;
    $this.uaf_1 = null;
    $this.vaf_1 = true;
    $this.waf_1 = -1.0;
    $this.xaf_1 = Companion_getInstance_28().i2c();
    $this.yaf_1 = Scale.x2i(1);
    return $this;
  }
  zaf() {
    super.zaf();
    this.vaf_1 = true;
  }
  jad(ctx) {
    if (!this.dai())
      return Unit_instance;
    if (!this.saf_1) {
      return super.jad(ctx);
    }
    if (this.uaf_1 == null) {
      this.uaf_1 = new CacheTexture(this, ctx);
      this.vaf_1 = true;
    }
    var cache = ensureNotNull(this.uaf_1);
    ctx.k8h(cache);
    var renderScale = ctx.a8h().k3_1 === 0 ? 1.0 : ctx.s8h();
    var tmp1_elvis_lhs = this.taf_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.a8h() : tmp1_elvis_lhs);
    if (this.vaf_1 || !(this.waf_1 === renderScale)) {
      this.waf_1 = renderScale;
      this.xaf_1 = this.l9y(VOID, false);
      this.yaf_1 = doExpensiveScaling ? this.yai().e1().z2i(this.xaf_1.e1()) : Scale.x2i(1);
      this.vaf_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.xaf_1.j29_1 * renderScale * this.yaf_1.m2g_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.xaf_1.k29_1 * renderScale * this.yaf_1.n2g_1), 1);
      cache.cax(texWidth, texHeight);
      ctx.r88();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.yaw_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.p8h(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.d87_1;
        var this_1 = this_0.m87_1;
        if (!(this_1.h87_1 === this_0)) {
          this_1.h87_1 = this_0;
          this_1.r88();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.i6x(0, 0, frameBuffer.l6m_1, frameBuffer.m6m_1);
          var temp = this_0.k88_1;
          this_0.u8e();
          this_0.k88_1 = scissor;
          try {
            if (true) {
              ctx.i8h(Colors_getInstance().m3z_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.fai().l2d(-this.xaf_1.h29_1, -this.xaf_1.i29_1).f2d(renderScale * this.yaf_1.m2g_1, renderScale * this.yaf_1.n2g_1);
            ctx.r88();
            var temp4 = ctx.s86_1;
            var temp2d = ctx.t86_1;
            ctx.t86_1 = matrix;
            ctx.s86_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.u6t(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.j6v();
              this_2.a7i(_unary__edvuaz + 1 | 0);
              this_2.b7i(this_2.j6v() + 1 | 0);
              var blockSize = this_2.n6t_1;
              var index0 = imul(this_2.j6v() - 1 | 0, blockSize);
              var index1 = imul(this_2.j6v(), blockSize);
              var texBlockSize = this_2.k6t_1.j71().e1();
              var texIndex0 = imul(this_2.j6v() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.j6v(), texBlockSize);
              if (this_2.j6v() > 0) {
                arraycopy(this_2.p6t_1, index0, this_2.p6t_1, index1, blockSize);
              } else {
                arrayfill(this_2.p6t_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.k6t_1;
              this_2.q6t_1.k7i($this$push.i71(), ctx.s86_1);
              if (true && this_2.j6v() >= 1) {
                var equals = arrayequal(this_2.p6t_1, index0, this_2.p6t_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.j6v();
                  this_2.a7i(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.jad(ctx);
            }finally {
              ctx.r88();
              ctx.s86_1 = temp4;
              ctx.t86_1 = temp2d;
              ctx.u6t(ProjViewUB_getInstance()).c7i();
            }
            break $l$block_0;
          }finally {
            this_0.u8e();
            this_0.k88_1 = temp;
          }
        }
      }finally {
        ctx.q8h();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.d87_1;
    var this_4 = this_3.m87_1;
    if (!(this_4.h87_1 === this_3)) {
      this_4.h87_1 = this_3;
      this_4.r88();
    }
    this_3.t88(cache.aax_1, VOID, VOID, VOID, VOID, this.n9y().p2d(this.xaf_1.h29_1, this.xaf_1.i29_1).h2d(1.0 / (renderScale * this.yaf_1.m2g_1), 1.0 / (renderScale * this.yaf_1.n2g_1)), VOID, this.iai(), this.i9s_1);
  }
  aag() {
    return this;
  }
  bag(view) {
    this.vaf_1 = true;
    var tmp0_safe_receiver = this.h27();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g9s_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.bag(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static fao(size, cache, clip) {
    size = size === VOID ? Size2D.e2a(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.waw(cache);
    $this.cao_1 = clip;
    $this.dao_1 = size;
    $this.eao_1 = Ref(false);
    return $this;
  }
  ead() {
    return this.dao_1;
  }
  gad() {
    return new Rectangle(0.0, 0.0, this.k2l(), this.l2l());
  }
  jad(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.cao_1;
      var renderingInternalRef = this.eao_1;
      if (renderingInternalRef.n1()) {
        super.jad(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.n9y();
        var hasRotation = !(m.l2c_1 === 0.0) || !(m.m2c_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.n1();
          try {
            renderingInternalRef.l2u(true);
            renderFiltered(this, ctx, Companion_getInstance_51());
          }finally {
            renderingInternalRef.l2u(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.d87_1;
        if (!(ctx.h87_1 === batcher)) {
          ctx.h87_1 = batcher;
          ctx.r88();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.f87_1;
        var bounds = this.caj(ctx).d2i(ctx.t86_1).e2i();
        var rect = c2d.w8h_1.e8e().q6x();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.s2h(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().l6x(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.w8h_1;
            var scissor_0 = c2d.e8i(scissor);
            var temp = this_0.k88_1;
            this_0.u8e();
            this_0.k88_1 = scissor_0;
            try {
              super.jad(ctx);
              break $l$block_1;
            }finally {
              this_0.u8e();
              this_0.k88_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.jad(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.jad(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static aad(size, cache) {
    Companion_getInstance_40();
    size = size === VOID ? Companion_getInstance_40().mal_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.fao(size, cache, false);
    $this.yac_1 = size;
    $this.zac_1 = false;
    return $this;
  }
  ead() {
    return this.yac_1;
  }
  gad() {
    return new Rectangle(0.0, 0.0, this.k2l(), this.l2l());
  }
  had() {
    super.had();
    this.iad();
  }
  iad() {
    this.dag();
  }
  jad(ctx) {
    registerUISupportOnce(this);
    super.jad(ctx);
  }
}
class SceneContainer extends UIView {
  static s9w(views, defaultTransition, name, size) {
    Companion_getInstance_39();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.r9q_1.e1() : size;
    var $this = this.aad(size);
    $this.m9w_1 = views;
    $this.n9w_1 = defaultTransition;
    $this.h9s_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.bad();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.ra3(this_0);
    tmp.o9w_1 = this_0;
    $this.p9w_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.v6d(tmp_0, SceneContainer$lambda($this));
    $this.q9w_1 = arrayListOf([Companion_getInstance_39().ja7_1]);
    $this.r9w_1 = 0;
    return $this;
  }
  cad(clazz, injects, time, transition, $completion) {
    this.dad(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  t9w(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.n9w_1 : transition;
    return $super === VOID ? this.cad(clazz, injects, time, transition, $completion) : $super.cad.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  ka7(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  dad(entry) {
    while (this.q9w_1.e1() <= this.r9w_1) {
      this.q9w_1.h(Companion_getInstance_39().ja7_1);
    }
    this.q9w_1.h3(this.r9w_1, entry);
  }
  b16() {
    return this.m9w_1.f9p_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static bad() {
    var $this = this.sa3();
    dummyView($this);
    dummyView($this);
    $this.za9_1 = Companion_getInstance_34().ry_1;
    $this.aaa_1 = get_AlphaTransition();
    return $this;
  }
  n1j() {
    return this.d1(0);
  }
  k1j() {
    return this.d1(1);
  }
  caa(next, transition) {
    this.aaa_1 = transition;
    this.za9_1 = Companion_getInstance_34().ry_1;
    this.baa_1 = transition.naj();
    this.oaj(this.k1j(), next);
    _get_transitionProcess__5hlux5(this).kaj(this.n1j(), this.k1j());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.za9_1) + ':transition=' + toString(this.aaa_1));
  }
  daa() {
    this.za9_1 = Companion_getInstance_34().uy_1;
    _get_transitionProcess__5hlux5(this).laj(this.n1j(), this.k1j());
    this.oaj(dummyView(this), this.k1j());
  }
  oaj(prev, next) {
    this.kag();
    this.lag(prev);
    this.lag(next);
  }
  jad(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.za9_1, Companion_getInstance_34().ry_1) <= 0) {
      this.n1j().fad(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.za9_1, Companion_getInstance_34().uy_1) >= 0) {
      this.k1j().fad(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).maj(ctx, this.n1j(), this.k1j(), this.za9_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.paj_1 = $render;
    this.qaj_1 = $name;
  }
  naj() {
    return this;
  }
  maj(ctx, prev, next, ratio) {
    return this.paj_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.qaj_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.raj_1 = $process;
    this.saj_1 = $easing;
  }
  kaj(prev, next) {
    return this.raj_1.kaj(prev, next);
  }
  laj(prev, next) {
    return this.raj_1.laj(prev, next);
  }
  maj(ctx, prev, next, ratio) {
    return this.raj_1.maj(ctx, prev, next, this.saj_1.my(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.taj_1 = $this_withEasing;
    this.uaj_1 = $easing;
  }
  toString() {
    return toString(this.taj_1) + '.withEasing';
  }
  naj() {
    var process = this.taj_1.naj();
    return new withEasing$1$create$1(process, this.uaj_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.vaj_1 = this.zaj(true, VOID, false);
    this.waj_1 = this.zaj(true, VOID, true);
    this.xaj_1 = this.aak(false, 'r', false);
    this.yaj_1 = this.aak(false, 'a', false);
  }
  aak(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().q8d_1;
    var tmp2_name = name == null ? Companion_getInstance_6().q8d_1.g6u_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.e75();
    var tmp_0 = this_0.e75();
    var tmp_1 = this_0.e75();
    var tmp_2 = this_0.e75();
    var median$delegate = this_0.t74(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).v71(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().n8d_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.y74(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.m75(this_0.g74());
    var alpha = this_0.n75(this_0.g74());
    this_0.s73(this_0.v73(), this_0.r75(this_0.v73(), this_0.z73([this_0.y73(0.5)])));
    if (msdf) {
      this_0.s73(d, this_0.w74(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.b74(this_0.v73(), 'r'), this_0.b74(this_0.v73(), 'g'), this_0.b74(this_0.v73(), 'b')));
    } else {
      this_0.s73(d, this_0.b74(this_0.v73(), sdf));
    }
    this_0.s73(alpha, this_0.v74(SDFShaders_getInstance().g8j(), d));
    if (inverted) {
      this_0.s73(alpha, this_0.r75(this_0.y73(1.0), alpha));
    }
    this_0.s73(this_0.v73(), this_0.w73(this_0.t73(), alpha));
    var tmp3_fragment = FragmentShader(this_0.a74());
    return tmp1_$this.y7q(VOID, tmp3_fragment, tmp2_name);
  }
  zaj(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.aak(msdf, sdf, inverted) : $super.aak.call(this, msdf, sdf, inverted);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.v1w() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.v1w() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.bak_1 = view;
    this.cak_1 = vs;
    this.dak_1 = fastTime;
    this.eak_1 = easing;
    this.fak_1 = callback;
    this.gak_1 = c;
    this.hak_1 = fastWaitTime;
    this.iak_1 = autoInvalidate;
    this.jak_1 = Companion_instance_1.u1w();
    var tmp = this;
    var tmp_0;
    if (!equals(this.dak_1, Companion_instance_1.v1w())) {
      tmp_0 = this.dak_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.cak_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.p8k_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.kak_1 = tmp_0;
    this.lak_1 = false;
    this.mak_1 = false;
    this.nak_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.oak_1 = this.bak_1.v6d(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.gak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a19(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.u1w());
  }
  vak() {
    return get_slow(this.hak_1);
  }
  wak() {
    if (this.nak_1)
      return Unit_instance;
    this.nak_1 = true;
    var tmp0_safe_receiver = this.gak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.uc(tmp$ret$0);
    }
  }
  uak() {
    if (this.mak_1)
      return Unit_instance;
    this.mak_1 = true;
    var tmp0_safe_receiver = this.oak_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.g6();
    }
    this.oak_1 = null;
    this.wak();
  }
  pak(elapsed) {
    if (equals(elapsed, Companion_instance_1.u1w())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.cak_1;
      var n = 0;
      while (n < this_0.e1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.d1(_unary__edvuaz).z38();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.cak_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.d1(_unary__edvuaz_0);
      var durationInTween = equals(v.n8k_1, Companion_instance_1.v1w()) ? FastDuration__minus_impl_evs237(this.kak_1, v.m8k_1) : v.n8k_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.m8k_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7(durationInTween, Companion_getInstance().oj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7_0(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.eak_1.ly(ratioInTween);
      v.s8k(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.bak_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.xak_1 = $this_tween;
    this.yak_1 = $tc;
    this.zak_1 = $vs;
    this.aal_1 = $time;
    this.bal_1 = $easing;
    this.cal_1 = $callback;
    this.dal_1 = $waitTime;
    this.eal_1 = $autoInvalidate;
  }
  h1p($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class UIObservable {
  constructor(initial, observe) {
    this.fal_1 = initial;
    this.gal_1 = observe;
    this.hal_1 = this.fal_1;
  }
  ial(obj, prop) {
    return this.hal_1;
  }
  jal(obj, prop, value) {
    if (!equals(this.hal_1, value)) {
      this.hal_1 = value;
      this.gal_1(value);
    }
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.kal_1 = 90.0;
    this.lal_1 = 32.0;
    this.mal_1 = Size2D.d2h(90.0, 32.0);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.oat_1 = 1.0;
    this.pat_1 = 1.0;
    this.qat_1 = 1.0;
    this.rat_1 = 1.0;
    this.sat_1 = 1.0;
    this.tat_1 = MatrixTransform.o2e();
  }
  uat(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.tat_1 = globalMatrix.s2d();
      // Inline function 'kotlin.math.abs' call
      var x = this.tat_1.g2e_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.tat_1.h2e_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.qat_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.rat_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.qat_1 = sx;
        this.rat_1 = sy;
        this.sat_1 = sxy;
        this.oat_1 = 1.0 / sx;
        this.pat_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.qat_1 = 1.0;
      this.rat_1 = 1.0;
      this.sat_1 = 1.0;
      this.oat_1 = 1.0;
      this.pat_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static obe(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ib5();
    $this.eaw_1 = smoothing;
    $this.uaw(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.faw_1 = get_Bitmaps_white();
    $this.gaw_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_15();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.haw_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.iaw_1 = null;
    $this.jaw_1 = null;
    return $this;
  }
  raw(v) {
    if (!(this.faw_1 === v)) {
      this.faw_1 = v;
      this.h9t_1 = true;
      this.zaf();
    }
  }
  gao(v) {
    if (!this.gaw_1.equals(v)) {
      this.gaw_1 = v;
      this.h9t_1 = true;
      this.zaf();
    }
  }
  kaw() {
    return this.gaw_1;
  }
  cau() {
    return 0.0;
  }
  dau() {
    return 0.0;
  }
  vag() {
    return this.kaw().h28_1 * this.cau();
  }
  wag() {
    return this.kaw().i28_1 * this.dau();
  }
  law() {
    return -this.vag();
  }
  maw() {
    return -this.wag();
  }
  jad(ctx) {
    if (!this.dai())
      return Unit_instance;
    var tmp = this.faw_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.h9t_1) {
      this.h9t_1 = false;
      this.taw();
    }
    this.saw(ctx);
  }
  saw(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d87_1;
    var this_1 = this_0.m87_1;
    if (!(this_1.h87_1 === this_0)) {
      this_1.h87_1 = this_0;
      this_1.r88();
    }
    var tmp0_safe_receiver = this.jaw_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.haw_1;
    var tex = ctx.j8h(this.faw_1).z3j();
    var smoothing = this.eaw_1;
    var blendMode = this.hai();
    var program = this.iaw_1;
    var vcount = array.o8e_1;
    var icount = array.p8e_1;
    var matrix = Companion_getInstance_30().g2c_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.o8b_1;
      this_0.h8e(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().q8d_1 : program;
      if (this_0.w8e(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.y8d();
      if (!contains(this_0.c88_1, tex_0)) {
        this_0.b88_1 = 0;
        this_0.c88_1[0] = tex_0;
      }
      this_0.d88_1 = smoothing;
      this_0.e88_1 = blendMode;
      this_0.f88_1 = pprogram;
    }
    this_0.t8e(array, matrix, vcount, icount);
  }
  taw() {
    this.haw_1.r8j(0, this.law(), this.maw(), this.cau(), this.dau(), this.n9y(), this.faw_1, this.iai());
  }
  gad() {
    return Companion_getInstance_28().c2h(this.law(), this.maw(), this.cau(), this.dau());
  }
  toString() {
    var out = super.toString();
    if (!this.kaw().equals(Companion_getInstance_25().y27_1))
      out = out + (':anchor=(' + this.qai(this.kaw().h28_1) + ', ' + this.qai(this.kaw().i28_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static fbe(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.obe(anchor, hitShape, smoothing);
    $this.lat_1 = false;
    $this.mat_1 = bitmap;
    $this.oaw();
    return $this;
  }
  static wat(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.fbe(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  bau(value) {
    if (equals(this.faw_1, value))
      return Unit_instance;
    this.lat_1 = true;
    this.raw(value);
  }
  t59() {
    return this.faw_1;
  }
  oaw() {
    if (this.lat_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  jad(ctx) {
    this.oaw();
    super.jad(ctx);
  }
  cau() {
    return this.faw_1.k2l();
  }
  dau() {
    return this.faw_1.l2l();
  }
  s3k() {
    return this.faw_1.s3k();
  }
  t3k() {
    return this.faw_1.t3k();
  }
  c3k() {
    return this.faw_1.c3k();
  }
  d3k() {
    return this.faw_1.d3k();
  }
  paw() {
    return this.kaw().h28_1 * this.c3k();
  }
  qaw() {
    return this.kaw().i28_1 * this.d3k();
  }
  vag() {
    return this.paw() - this.s3k();
  }
  wag() {
    return this.qaw() - this.t3k();
  }
  gad() {
    return Companion_getInstance_28().c2h(-this.paw(), -this.qaw(), this.c3k(), this.d3k());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.t59()));
  }
}
class BaseGraphics extends BaseImage {
  static vat(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.wat(tmp$ret$0);
    $this.paq_1 = autoScaling;
    $this.qaq_1 = true;
    $this.raq_1 = false;
    $this.saq_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.taq_1 = ArrayList.i1();
    $this.uaq_1 = new InternalViewAutoscaling();
    $this.vaq_1 = 1;
    $this.waq_1 = true;
    $this.xaq_1 = true;
    $this.yaq_1 = null;
    $this.zaq_1 = 1.0;
    $this.aar_1 = 1.0;
    $this.bar_1 = true;
    $this.car_1 = true;
    $this.dar_1 = Companion_getInstance_28().i2c();
    $this.ear_1 = Companion_getInstance_28().i2c();
    return $this;
  }
  xat(value) {
    this.qaq_1 = value;
    this.yat();
  }
  yat() {
    this.waq_1 = true;
    this.xaq_1 = true;
    this.kai();
  }
  had() {
    super.had();
    if (this.h27() == null || this.bai() == null) {
      var tmp = this.t59().z3j();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.taq_1.h(this.t59().z3j());
      }
      clearBitmaps(this, true);
    }
  }
  jad(ctx) {
    this.yaq_1 = ctx;
    clearBitmaps(this, false);
    this.zat();
    super.jad(ctx);
  }
  zat() {
    if (this.uaq_1.uat(this.paq_1, this.raq_1, this.n9y())) {
      this.waq_1 = true;
    }
    if (!this.waq_1)
      return false;
    this.waq_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.taq_1.h(this.t59().z3j());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.j29_1 * this.uaq_1.qat_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.k29_1 * this.uaq_1.rat_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.vaq_1 | 0, imageHeight + this.vaq_1 | 0, this.qaq_1, true);
    this.zaq_1 = this.uaq_1.qat_1;
    this.aar_1 = this.uaq_1.rat_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.e3y_1;
    if (true) {
      image.n3y();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.w45(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.i58(this.zaq_1, this.aar_1);
        ctx.m4r(-boundsWithShapes.h29_1, -boundsWithShapes.i29_1);
        this.aau(ctx);
      }finally {
        ctx.m19();
      }
    }finally {
      result = true ? image.p3y(rect) : 0;
    }
    this.bau(slice(image));
    return true;
  }
  cau() {
    return _get_bitmapWidth__ndy7bu(this) / this.zaq_1;
  }
  dau() {
    return _get_bitmapHeight__5t1vx1(this) / this.aar_1;
  }
  c3k() {
    return this.cau();
  }
  d3k() {
    return this.dau();
  }
  vag() {
    return this.kaw().h28_1 * this.cau();
  }
  wag() {
    return this.kaw().i28_1 * this.dau();
  }
  law() {
    return _getLocalBoundsInternal(this, this.bar_1).h29_1;
  }
  maw() {
    return _getLocalBoundsInternal(this, this.bar_1).i29_1;
  }
  gad() {
    return _getLocalBoundsInternal$default(this);
  }
  naw(value) {
    this.car_1 = value;
    this.kai();
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.bax_1 = $outer;
    this.xaw_1 = ctx;
    this.yaw_1 = this.xaw_1.n8h(16, 16, VOID, VOID, VOID, false);
    this.zaw_1 = TextureBase.r8b(this.yaw_1.j6r(), 16, 16);
    this.aax_1 = Texture(this.zaw_1);
  }
  cax(width, height) {
    this.yaw_1.l6r(0, 0, width, height);
    this.zaw_1.s8b(width);
    this.zaw_1.t8b(height);
    this.aax_1 = Texture(this.zaw_1);
  }
  g6() {
    this.bax_1.uaf_1 = null;
    this.xaw_1.o8h(this.yaw_1);
  }
}
class ZIndexComparator {
  dax(a, b) {
    return compareTo(a.jah(), b.jah());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.dax(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.uaz_1 = this$0;
    this.taz_1 = 0;
  }
  b1() {
    return this.taz_1 < this.uaz_1.raz_1.fag();
  }
  c1() {
    var _unary__edvuaz = this.taz_1;
    this.taz_1 = _unary__edvuaz + 1 | 0;
    return this.uaz_1.raz_1.hag(_unary__edvuaz);
  }
  k6() {
    this.taz_1 = this.taz_1 - 1 | 0;
    this.uaz_1.raz_1.iag(this.taz_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.qaz_1 = children;
    this.raz_1 = container;
  }
  e1() {
    return this.raz_1.fag();
  }
  vaz(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.h27() === this.raz_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  t2(elements) {
    return this.vaz(elements);
  }
  g1() {
    return this.raz_1.fag() === 0;
  }
  waz(element) {
    this.raz_1.lag(element);
    return true;
  }
  h(element) {
    return this.waz(element instanceof View ? element : THROW_CCE());
  }
  xaz(elements) {
    if (elements.g1())
      return false;
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.raz_1.lag(element);
    }
    return true;
  }
  f1(elements) {
    return this.xaz(elements);
  }
  a1() {
    return new ContainerCollection$iterator$1(this);
  }
  yaz(element) {
    return this.raz_1.tag(element);
  }
  g3(element) {
    if (!(element instanceof View))
      return false;
    return this.yaz(element instanceof View ? element : THROW_CCE());
  }
  d1(index) {
    return this.qaz_1.d1(index);
  }
  u2() {
    return this.qaz_1.u2();
  }
  v2(index) {
    return this.qaz_1.v2(index);
  }
  w2(fromIndex, toIndex) {
    return this.qaz_1.w2(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static fb3(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.vat(autoScaling);
    $this.xb2_1 = 0;
    $this.yb2_1 = null;
    $this.zb2_1 = true;
    $this.ab3_1 = -1;
    $this.bb3_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.cb3_1 = ArrayList.i1();
    $this.db3_1 = null;
    $this.eb3_1 = null;
    $this.r9t_1 = true;
    return $this;
  }
  gb3(value) {
    this.yb2_1 = value;
    this.xb2_1 = this.xb2_1 + 1 | 0;
    this.yat();
  }
  uaw(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.eb3_1 = tmp_0;
  }
  xag() {
    var tmp0_safe_receiver = this.yag();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  yag() {
    if (!(this.eb3_1 == null))
      return this.eb3_1;
    if (!(this.ab3_1 === this.xb2_1)) {
      this.ab3_1 = this.xb2_1;
      this.cb3_1.e3();
      var tmp = this.cb3_1;
      var tmp0_safe_receiver = this.yb2_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y4s();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.cb3_1;
  }
  aau(ctx) {
    var tmp0_safe_receiver = this.yb2_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f4s(ctx);
    }
  }
  nat(includeStrokes) {
    var tmp0_safe_receiver = this.yb2_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o5n(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_28().t29_1 : tmp1_elvis_lhs;
  }
}
class DummyView extends View {
  static hb5() {
    return this.ib5();
  }
  jad(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class FixedSizeContainer extends Container {
  static jb5(size, clip) {
    size = size === VOID ? Size2D.e2a(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.sa3();
    $this.maz_1 = clip;
    $this.naz_1 = size;
    $this.oaz_1 = Ref(false);
    return $this;
  }
  w5n() {
    return this.maz_1;
  }
  ead() {
    return this.naz_1;
  }
  gad() {
    return new Rectangle(0.0, 0.0, this.k2l(), this.l2l());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.k2l()) + 'x' + get_niceStr(this.l2l()) + ')');
    return out;
  }
  jad(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.w5n();
      var renderingInternalRef = this.oaz_1;
      if (renderingInternalRef.n1()) {
        super.jad(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.n9y();
        var hasRotation = !(m.l2c_1 === 0.0) || !(m.m2c_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.n1();
          try {
            renderingInternalRef.l2u(true);
            renderFiltered(this, ctx, Companion_getInstance_51());
          }finally {
            renderingInternalRef.l2u(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.d87_1;
        if (!(ctx.h87_1 === batcher)) {
          ctx.h87_1 = batcher;
          ctx.r88();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.f87_1;
        var bounds = this.caj(ctx).d2i(ctx.t86_1).e2i();
        var rect = c2d.w8h_1.e8e().q6x();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.s2h(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().l6x(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.w8h_1;
            var scissor_0 = c2d.e8i(scissor);
            var temp = this_0.k88_1;
            this_0.u8e();
            this_0.k88_1 = scissor_0;
            try {
              super.jad(ctx);
              break $l$block_1;
            }finally {
              this_0.u8e();
              this_0.k88_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.jad(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.jad(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static ga6(size, clip) {
    size = size === VOID ? Size2D.e2a(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.jb5(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.lb5_1 = capacity;
    this.mb5_1 = IntDeque.g2q(this.lb5_1);
    this.nb5_1 = 0;
  }
  e1() {
    return this.mb5_1.e1();
  }
  ob5() {
    return this.mb5_1.e1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.nb5_1 / this.mb5_1.e1());
  }
  pb5() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.ob5());
  }
  qb5(index) {
    return get_fastMicroseconds_0(this.mb5_1.d1(index));
  }
  rb5(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.mb5_1.l2q(intValue);
    this.nb5_1 = this.nb5_1 + intValue | 0;
    if (this.mb5_1.e1() > this.lb5_1) {
      this.nb5_1 = this.nb5_1 - this.mb5_1.rk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static kbb(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.sa3();
    $this.ab8_1 = null;
    $this.bb8_1 = null;
    $this.cb8_1 = true;
    $this.db8_1 = false;
    $this.eb8_1 = true;
    $this.fb8_1 = true;
    $this.gb8_1 = EmptyShape_instance;
    $this.hb8_1 = renderer;
    $this.ibb(shape);
    return $this;
  }
  lbb() {
    var tmp0_elvis_lhs = this.ab8_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.bb8_1 : tmp0_elvis_lhs);
  }
  naw(value) {
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.naw(value);
    }
    var tmp1_safe_receiver = this.bb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.naw(value);
    }
    this.zaf();
    this.kai();
  }
  mbb() {
    var tmp0_safe_receiver = this.ab8_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.car_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.bb8_1;
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.lba_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  }
  gao(value) {
    _get_anchorable__ebfoik(this).gao(value);
    this.zaf();
  }
  kaw() {
    return _get_anchorable__ebfoik(this).kaw();
  }
  vag() {
    return this.lbb().vag();
  }
  wag() {
    return this.lbb().wag();
  }
  jbb(value) {
    if (this.cb8_1 === value)
      return Unit_instance;
    this.cb8_1 = value;
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.zb2_1 = value;
    }
    var tmp1_safe_receiver = this.bb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.jbb(value);
    }
    this.zaf();
  }
  nbb(value) {
    if (this.eb8_1 === value)
      return Unit_instance;
    this.eb8_1 = value;
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.eaw_1 = value;
    }
    var tmp1_safe_receiver = this.bb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.kba_1 = value;
    }
    this.zaf();
  }
  obb(value) {
    if (this.fb8_1 === value)
      return Unit_instance;
    this.fb8_1 = value;
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.paq_1 = value;
    }
    var tmp1_safe_receiver = this.bb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.iba_1 = value;
    }
    this.zaf();
  }
  ibb(value) {
    if (this.gb8_1 === value)
      return Unit_instance;
    this.gb8_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.gb3(value);
    }
    var tmp1_safe_receiver = this.bb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ibb(value);
    }
    this.zaf();
  }
  pbb(value) {
    if (this.hb8_1 === value)
      return Unit_instance;
    this.hb8_1 = value;
    this.qbb();
  }
  qbb() {
    ensure(this);
    var tmp0_safe_receiver = this.ab8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yat();
    }
    var tmp1_safe_receiver = this.ab8_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.zat();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.c9q_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.ibe(views, currentVfs, sourceFile, $completion) : $super.ibe.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static ebe(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.fbe(bitmap, anchor, hitShape, smoothing);
    $this.zbd_1 = new Mixin_0();
    $this.abe_1 = sourceFile$factory($this);
    return $this;
  }
  static gbe(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.ebe(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  jad(ctx) {
    this.hbe(ctx, this);
    super.jad(ctx);
  }
  ibe(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  kbe(_set____db54di) {
    this.zbd_1.cbe_1 = _set____db54di;
  }
  lbe(_set____db54di) {
    this.zbd_1.lbe(_set____db54di);
  }
  mbe() {
    return this.zbd_1.dbe_1;
  }
  bbe(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  hbe(ctx, view) {
    this.zbd_1.hbe(ctx, view);
  }
}
class Line extends View {
  static ubg(p1, p2, color) {
    color = color === VOID ? Colors_getInstance().h3z_1 : color;
    var $this = this.ib5();
    $this.sbg_1 = p2;
    $this.tbg_1 = pos$factory($this);
    $this.s4r(p1);
    $this.t4e(color);
    return $this;
  }
  t2b() {
    return this.w6h();
  }
  u2b() {
    return this.x6h();
  }
  vbg() {
    return this.sbg_1.x28_1;
  }
  wbg() {
    return this.sbg_1.y28_1;
  }
  jad(ctx) {
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.f8g_1;
    if (!(this_1.h87_1 === this_0)) {
      this_1.h87_1 = this_0;
      this_1.r88();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.r8g_1 = null;
        // Inline function 'korlibs.korge.view.Line.renderInternal.<anonymous>' call
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
        var matrix = this.n9y();
        $l$block: {
          // Inline function 'korlibs.datastructure.keep' call
          var mut_0 = currentMatrix$factory_1(this_0);
          var temp_0 = mut_0.get();
          try {
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
            if (!(matrix == null))
              this_0.r8g_1 = matrix;
            var col = this.iai();
            this_0.x8g(0.0, 0.0, this.vbg() - this.t2b(), this.wbg() - this.u2b(), col, col);
            break $l$block;
          }finally {
            mut_0.set(temp_0);
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
}
class ShapeView extends Container {
  static rbm(shape, fill, stroke, strokeThickness, autoScaling, renderer) {
    shape = shape === VOID ? null : shape;
    fill = fill === VOID ? new RGBA(Colors_getInstance().h3z_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().h3z_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 1.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.sa3();
    $this.fbj_1 = addTo(Graphics.kbb(VOID, renderer), $this);
    $this.fbj_1.obb(autoScaling);
    $this.gbj_1 = anchor$factory($this.fbj_1);
    $this.hbj_1 = antialiased$factory($this.fbj_1);
    $this.ibj_1 = autoScaling$factory($this.fbj_1);
    $this.jbj_1 = renderer$factory($this.fbj_1);
    $this.kbj_1 = smoothing$factory($this.fbj_1);
    $this.lbj_1 = boundsIncludeStrokes$factory($this.fbj_1);
    $this.mbj_1 = shape;
    $this.nbj_1 = fill;
    $this.obj_1 = stroke;
    $this.pbj_1 = numberToDouble(strokeThickness);
    $this.pbm();
    $this.qbj_1 = new VectorPath();
    return $this;
  }
  gao(_set____db54di) {
    var this_0 = this.gbj_1;
    anchor$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  kaw() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.gbj_1;
    anchor$factory_1();
    return this_0.get();
  }
  vag() {
    return this.fbj_1.vag();
  }
  wag() {
    return this.fbj_1.wag();
  }
  g25() {
    return this.mbj_1;
  }
  pbm() {
    // Inline function 'korlibs.korge.view.Graphics.updateShape' call
    var this_0 = this.fbj_1;
    var result;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_1 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
    var shapeView = this;
    var shape = shapeView.g25();
    if (!(shape == null) && shape.e2b()) {
      if (!(shapeView.pbj_1 === 0.0)) {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = shapeView.nbj_1;
        var stroke = shapeView.obj_1;
        var strokeInfo = new StrokeInfo(shapeView.pbj_1);
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.h58(shape);
        if (!(fill == null)) {
          this_1.n4p(fill);
        }
        if (!(stroke == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.z3a_1;
              var lineCap = strokeInfo.c3b_1;
              var lineJoin = strokeInfo.e3b_1;
              var miterLimit = strokeInfo.f3b_1;
              var lineDash = strokeInfo.g3b_1;
              var lineDashOffset = strokeInfo.h3b_1;
              if (false) {
                this_1.b4o();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              this_1.u4p();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                this_1.v4p(numberToDouble(lineWidth));
                this_1.w4p(lineCap);
                this_1.x4p(lineJoin);
                this_1.y4p(numberToDouble(miterLimit));
                this_1.z4p(lineDash);
                this_1.a4q(numberToDouble(lineDashOffset));
                this_1.b4q(stroke);
              }finally {
                this_1.c4q();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = this_1.o4p();
            var lineCap_0 = this_1.p4p();
            var lineJoin_0 = this_1.q4p();
            var miterLimit_0 = this_1.r4p();
            var lineDash_0 = this_1.s4p();
            var lineDashOffset_0 = this_1.t4p();
            if (false) {
              this_1.b4o();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            this_1.u4p();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              this_1.v4p(numberToDouble(lineWidth_0));
              this_1.w4p(lineCap_0);
              this_1.x4p(lineJoin_0);
              this_1.y4p(numberToDouble(miterLimit_0));
              this_1.z4p(lineDash_0);
              this_1.a4q(numberToDouble(lineDashOffset_0));
              this_1.b4q(stroke);
            }finally {
              this_1.c4q();
            }
          }
        }
      } else {
        // Inline function 'korlibs.image.vector.Context2d.fill' call
        var paint = shapeView.nbj_1;
        if (true) {
          this_1.b4o();
        }
        // Inline function 'korlibs.korge.view.ShapeView._updateShapeGraphics.<anonymous>.<anonymous>' call
        this_1.h58(shape);
        this_1.l5m(paint, null);
      }
    }
    result = Unit_instance;
    var tmp$ret$4 = this_1.j4m();
    this_0.ibb(tmp$ret$4);
  }
}
class RoundRect extends ShapeView {
  static qbm(size, radius, fill, stroke, strokeThickness, autoScaling) {
    fill = fill === VOID ? new RGBA(Colors_getInstance().h3z_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().h3z_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.rbm(new VectorPath(), fill, stroke, strokeThickness, autoScaling);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe = RoundRect$unscaledSize$delegate$lambda($this);
    tmp.lbm_1 = new UIObservable(size, observe);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe_0 = RoundRect$radius$delegate$lambda($this);
    tmp_0.mbm_1 = new UIObservable(radius, observe_0);
    $this.nbm_1 = colorMul$factory($this);
    updateGraphics($this);
    return $this;
  }
  sbm(_set____db54di) {
    return this.lbm_1.jal(this, unscaledSize$factory(), _set____db54di);
  }
  ead() {
    return this.lbm_1.ial(this, unscaledSize$factory_0());
  }
  tbm(_set____db54di) {
    return this.mbm_1.jal(this, radius$factory(), _set____db54di);
  }
  obm() {
    return this.mbm_1.ial(this, radius$factory_0());
  }
}
class Companion_5 {}
class Companion_6 {}
class SolidRect extends RectBase {
  static bbp(size, color) {
    color = color === VOID ? Colors_getInstance().h3z_1 : color;
    var $this = this.obe();
    $this.abp_1 = size;
    $this.t4e(color);
    return $this;
  }
  ead() {
    return this.abp_1;
  }
  cau() {
    return this.k2l();
  }
  dau() {
    return this.l2l();
  }
}
class Sprite extends BaseImage {
  static hbs(bitmap, anchor, hitShape, smoothing) {
    var tmp;
    if (bitmap === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bitmap;
    }
    bitmap = tmp;
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.wat(bitmap, anchor, hitShape, smoothing);
    $this.kbr_1 = false;
    $this.lbr_1 = 0;
    $this.mbr_1 = 0;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    tmp_0.nbr_1 = _AnimationType___init__impl__l3ftd1(0);
    $this.obr_1 = null;
    $this.pbr_1 = null;
    $this.qbr_1 = null;
    $this.rbr_1 = null;
    $this.sbr_1 = get_fastMilliseconds(50);
    $this.tbr_1 = false;
    $this.ubr_1 = get_fastSeconds(0);
    $this.vbr_1 = get_fastSeconds(0);
    $this.wbr_1 = null;
    $this.xbr_1 = 0;
    $this.ybr_1 = false;
    addFastUpdater_0($this, Sprite$lambda);
    return $this;
  }
  static ibs(initialAnimation, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().y27_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.hbs(initialAnimation.jbs(), anchor, hitShape, smoothing);
    $this.wbr_1 = initialAnimation;
    $this.kbs(0);
    return $this;
  }
  bbs() {
    if (this.obr_1 == null)
      this.obr_1 = new Signal();
    return ensureNotNull(this.obr_1);
  }
  abs() {
    if (this.pbr_1 == null)
      this.pbr_1 = new Signal();
    return ensureNotNull(this.pbr_1);
  }
  lbs(spriteAnimation, spriteDisplayTime, startFrame, endFrame, reversed) {
    var tmp = startFrame >= 0 ? startFrame : this.xbr_1;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    var tmp$ret$0 = _AnimationType___init__impl__l3ftd1(0);
    return updateCurrentAnimation$default(this, spriteAnimation, spriteDisplayTime, 1, VOID, tmp, endFrame, VOID, reversed, tmp$ret$0);
  }
  mbs(spriteAnimation, spriteDisplayTime, startFrame, endFrame, reversed, $super) {
    spriteAnimation = spriteAnimation === VOID ? this.wbr_1 : spriteAnimation;
    spriteDisplayTime = spriteDisplayTime === VOID ? getDefaultTime(this, spriteAnimation) : spriteDisplayTime;
    startFrame = startFrame === VOID ? -1 : startFrame;
    endFrame = endFrame === VOID ? 0 : endFrame;
    reversed = reversed === VOID ? false : reversed;
    var tmp;
    if ($super === VOID) {
      this.lbs(spriteAnimation, spriteDisplayTime, startFrame, endFrame, reversed);
      tmp = Unit_instance;
    } else {
      tmp = $super.lbs.call(this, spriteAnimation, new FastDuration(spriteDisplayTime), startFrame, endFrame, reversed);
    }
    return tmp;
  }
  nbs(spriteAnimation, spriteDisplayTime, startFrame, reversed) {
    var tmp = startFrame >= 0 ? startFrame : this.xbr_1;
    // Inline function 'korlibs.korge.view.Companion.LOOPED' call
    var tmp$ret$0 = _AnimationType___init__impl__l3ftd1(1);
    return updateCurrentAnimation$default(this, spriteAnimation, spriteDisplayTime, VOID, VOID, tmp, VOID, true, reversed, tmp$ret$0);
  }
  obs(spriteAnimation, spriteDisplayTime, startFrame, reversed, $super) {
    spriteAnimation = spriteAnimation === VOID ? this.wbr_1 : spriteAnimation;
    spriteDisplayTime = spriteDisplayTime === VOID ? getDefaultTime(this, spriteAnimation) : spriteDisplayTime;
    startFrame = startFrame === VOID ? -1 : startFrame;
    reversed = reversed === VOID ? false : reversed;
    var tmp;
    if ($super === VOID) {
      this.nbs(spriteAnimation, spriteDisplayTime, startFrame, reversed);
      tmp = Unit_instance;
    } else {
      tmp = $super.nbs.call(this, spriteAnimation, new FastDuration(spriteDisplayTime), startFrame, reversed);
    }
    return tmp;
  }
  zbr() {
    this.kbr_1 = false;
    triggerEvent(this, this.pbr_1);
  }
  cbs() {
    var tmp0_elvis_lhs = this.wbr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ca = tmp;
    return ca.e1();
  }
  kbs(index) {
    _set_currentSpriteIndex__7b2y7x(this, index);
  }
}
class Companion_7 {}
class Companion_8 {}
class SpriteAnimation {
  static pbs(sprites, fastDefaultTimePerFrame) {
    fastDefaultTimePerFrame = fastDefaultTimePerFrame === VOID ? Companion_instance_1.v1w() : fastDefaultTimePerFrame;
    var $this = createThis(this);
    $this.dbs_1 = sprites;
    $this.ebs_1 = fastDefaultTimePerFrame;
    return $this;
  }
  static qbs(sprites, defaultTimePerFrame) {
    return this.pbs(sprites, get_fast(defaultTimePerFrame));
  }
  gbs() {
    return this.dbs_1.e1();
  }
  jbs() {
    return this.dbs_1.d1(0);
  }
  fbs(index) {
    return this.dbs_1.d1(umod(index, this.dbs_1.e1()));
  }
  rbs(elements) {
    return this.dbs_1.t2(elements);
  }
  t2(elements) {
    return this.rbs(elements);
  }
  g1() {
    return this.dbs_1.g1();
  }
  a1() {
    return this.dbs_1.a1();
  }
  e1() {
    return this.dbs_1.e1();
  }
}
class Stage extends FixedSizeContainer {
  static q9o(views) {
    var $this = this.jb5();
    $this.m9o_1 = views.p9p_1;
    $this.n9o_1 = views;
    $this.o9o_1 = clipBorders$factory($this.ka0());
    $this.p9o_1 = virtualSizeDouble$factory($this.ka0());
    $this.aah($this);
    $this.cah($this);
    return $this;
  }
  ka0() {
    return this.n9o_1;
  }
  sbs(_set____db54di) {
    var this_0 = this.o9o_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  w5n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o9o_1;
    clip$factory_0();
    return this_0.get();
  }
  sbm(_set____db54di) {
    var this_0 = this.p9o_1;
    unscaledSize$factory_1();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ead() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p9o_1;
    unscaledSize$factory_2();
    return this_0.get();
  }
  bai() {
    return this;
  }
  aag() {
    return this;
  }
  l8a() {
    return this.saz(this.ka0());
  }
  bag(view) {
    this.ka0().bag(view);
  }
  toString() {
    return 'Stage';
  }
  b16() {
    return this.n9o_1.f9p_1;
  }
  a8g(pos) {
    return this.m9o_1.a8g(pos);
  }
  p8f(value) {
    this.m9o_1.p8f(value);
  }
  q8f() {
    return this.m9o_1.q8f();
  }
  r8f(value) {
    this.m9o_1.r8f(value);
  }
  s8f() {
    return this.m9o_1.s8f();
  }
  t8f(value) {
    this.m9o_1.t8f(value);
  }
  u8f() {
    return this.m9o_1.u8f();
  }
  v8f(value) {
    this.m9o_1.v8f(value);
  }
  w8f() {
    return this.m9o_1.w8f();
  }
  x8f(value) {
    this.m9o_1.x8f(value);
  }
  y8f() {
    return this.m9o_1.y8f();
  }
  z8f() {
    return this.m9o_1.z8f();
  }
}
class Companion_9 {
  constructor() {
    this.ubw_1 = 16.0;
    this.vbw_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.vbs_1 = this$0;
    this.wbs_1 = $ctx;
    this.xbs_1 = $fontSource;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static zbw(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_24.ubw_1 : textSize;
    color = color === VOID ? Colors_getInstance().h3z_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().h4n_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_24.vbw_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.sa3();
    $this.gbv_1 = true;
    $this.hbv_1 = -1;
    $this.ibv_1 = -1;
    $this.jbv_1 = 0;
    $this.kbv_1 = 0;
    $this.lbv_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.mbv_1 = fill == null ? new RGBA(color) : fill;
    $this.nbv_1 = stroke;
    $this.obv_1 = font;
    $this.pbv_1 = numberToDouble(textSize);
    $this.qbv_1 = textSize$factory($this);
    $this.rbv_1 = 0;
    $this.sbv_1 = 2147483647;
    $this.tbv_1 = renderer;
    $this.ubv_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.sa3(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.vbv_1 = addTo(this_0, $this);
    $this.wbv_1 = new Text2TextRendererActions();
    $this.xbv_1 = false;
    $this.ybv_1 = autoScaling;
    $this.zbv_1 = false;
    $this.abw_1 = null;
    $this.bbw_1 = Companion_getInstance_28().b2h(0, 0, 2048, 2048);
    $this.cbw_1 = true;
    $this.dbw_1 = -1;
    $this.ebw_1 = new MMatrix();
    $this.fbw_1 = -1;
    $this.gbw_1 = null;
    $this.hbw_1 = new Entry();
    $this.ibw_1 = new FontMetrics();
    $this.jbw_1 = new TextMetrics();
    $this.kbw_1 = null;
    $this.lbw_1 = null;
    $this.mbw_1 = null;
    $this.nbw_1 = null;
    $this.obw_1 = new MMatrix();
    $this.pbw_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.qbw_1 = true;
    $this.rbw_1 = null;
    $this.sbw_1 = fontSource$factory($this);
    return $this;
  }
  abx(value) {
    if (!(this.lbv_1 === value)) {
      this.lbv_1 = value;
      updateLineCount(this);
      this.dag();
      this.zaf();
    }
  }
  wbw() {
    return this.lbv_1;
  }
  d55() {
    var tmp = this.mbv_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.d4f_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().h3z_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  ybw(value) {
    if (!equals(this.obv_1, value)) {
      this.obv_1 = value;
      this.dag();
    }
  }
  bbx(value) {
    if (!(this.pbv_1 === value)) {
      this.pbv_1 = value;
      this.dag();
    }
  }
  cbx(_set____db54di) {
    var this_0 = this.qbv_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  h4g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.qbv_1;
    fontSize$factory_0();
    return this_0.get();
  }
  dag() {
    this.jbv_1 = this.jbv_1 + 1 | 0;
    super.dag();
  }
  f5m() {
    return this.ubv_1.z4o_1;
  }
  z5i() {
    return this.ubv_1.a4p_1;
  }
  xbw(value) {
    this.abw_1 = value;
    this.xbv_1 = false;
    this.dag();
  }
  tbw(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  gad() {
    this.dbx(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.gad();
    } else {
      return this.bbw_1;
    }
  }
  jad(ctx) {
    this.dbx(ctx);
    var tva = this.nbw_1;
    if (!(tva == null)) {
      this.ebw_1.q3r(this.n9y());
      this.ebw_1.r3r(this.vbv_1.w6h(), this.vbv_1.x6h());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d87_1;
      var this_1 = this_0.m87_1;
      if (!(this_1.h87_1 === this_0)) {
        this_1.h87_1 = this_0;
        this_1.r88();
      }
      var tmp = this.obv_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.m4g();
      this_0.y8e(tex, this.gbv_1, this.hai(), get_agProgram(bmpfont), tva.p8e_1, tva.o8e_1);
      this_0.t8e(tva, this.ebw_1.o3r());
    } else {
      super.jad(ctx);
    }
  }
  dbx(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.abw_1;
      if (!this.xbv_1 && !(fontSource == null)) {
        this.xbv_1 = true;
        launchImmediately_0(ctx.j86_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.obv_1.g10();
    var tmp;
    var tmp_0;
    if (this.cbw_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.dbw_1 === this.jbv_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.dbw_1 = this.jbv_1;
      var metrics = getTextBounds(font, this.pbv_1, this.wbw(), this.jbw_1, this.tbv_1, this.ubv_1);
      this.bbw_1 = new Rectangle(metrics.o29(), VerticalAlign__getOffsetY_impl_iso0y6(this.ubv_1.a4p_1, metrics.l2l(), -metrics.h4p()), metrics.k2l(), font.q4g(this.pbv_1, this.ibw_1).i4g() * this.kbv_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.tbv_1.s5h();
        if (!(this.lbw_1 === this.gbv_1) || !(this.hbv_1 === this.jbv_1) || !(this.ibv_1 === rversion)) {
          this.lbw_1 = this.gbv_1;
          this.ibv_1 = rversion;
          this.hbv_1 = this.jbv_1;
          if (!(this.rbw_1 == null)) {
            this.rbw_1 = null;
            this.vbv_1.kag();
          }
          this.wbv_1.d5j();
          this.wbv_1.q5i_1 = Companion_getInstance_3().l4n_1;
          invoke(this.tbv_1, this.wbv_1, this.wbw(), this.pbv_1, font);
          while (this.vbv_1.fag() < this.wbv_1.e1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.vbv_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_25().y27_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.gbe(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.vbv_1.fag() > this.wbv_1.e1()) {
            this.vbv_1.d1(this.vbv_1.fag() - 1 | 0).wai();
          }
          var bounds = this.wbv_1.h3d();
          var firstBounds = this.wbv_1.b5j(0);
          var lineInfos = this.wbv_1.a5j();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.z5h_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.j29_1;
          var textHeight = bounds.k29_1;
          var dx = this.cbw_1 ? this.bbw_1.h29_1 : this.bbw_1.h29_1 + 1 + (this.bbw_1.j29_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.f5m());
          var tmp_2;
          if (this.cbw_1) {
            tmp_2 = this.bbw_1.i29_1 + firstLineInfos.x5h_1;
          } else {
            var tmp2_subject = this.z5i();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().g5h_1) ? this.bbw_1.i29_1 : this.bbw_1.i29_1 + firstLineInfos.x5h_1 + (this.bbw_1.k29_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.z5i());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.wbv_1.e1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.wbv_1.c5j(n, this.hbw_1);
              var tmp_3 = this.vbv_1.d1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.iaw_1 = program;
              it.t4e(this.d55());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.l28(numberToDouble(0), numberToDouble(0)));
              it.eaw_1 = this.gbv_1;
              it.bau(entry.a5i_1);
              it.s4r(Vector2D.d2b(entry.b5i_1 + dx, entry.c5i_1 + dy));
              it.qah(Scale.o2g(entry.d5i_1, entry.e5i_1));
              it.nbe(entry.f5i_1);
              var containsLower = this.rbv_1;
              it.e8p(n < this.sbv_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.lbw_1 === this.gbv_1) || !(this.mbw_1 === this.qbw_1)) {
          this.jbv_1 = this.jbv_1 + 1 | 0;
          this.mbw_1 = this.qbw_1;
          this.kbw_1 = this.ybv_1;
          this.lbw_1 = this.gbv_1;
        }
        if (!(this.hbv_1 === this.jbv_1)) {
          this.hbv_1 = this.jbv_1;
          var realTextSize = this.pbv_1;
          if (this.rbw_1 == null) {
            this.vbv_1.kag();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.vbv_1;
            var renderer = this.pbw_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.kbb(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).j4m();
            this_3.ibb(tmp$ret$10);
            this_3.qbb();
            tmp_4.rbw_1 = this_3;
            var tmp3_safe_receiver = this.rbw_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.obb(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.rbw_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.wbw();
          var tmp1_pos = Companion_getInstance_27().z28_1;
          var tmp2_paint = this.d55();
          var tmp3_renderer = this.tbv_1;
          var tmp4_align = this.ubv_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.mbv_1;
          var tmp7_stroke = this.nbv_1;
          var tmp8_textRangeStart = this.rbv_1;
          var tmp9_textRangeEnd = this.sbv_1;
          result_0 = this_5.p5m(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.j4m();
          this_4.ibb(tmp$ret$16);
          var metrics_0 = result_0;
          this.fbw_1 = this.jbv_1;
          this.gbw_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_27().z28_1, font.q4g(this.h4g(), this.ibw_1).u4g_1);
        }
        var tmp4_safe_receiver = this.rbw_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.nbb(this.gbv_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_10 {
  ebx(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h27();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h27();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.oai(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.nbx_1 = $view;
    this.obx_1 = $ctx;
    this.pbx_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.cbe_1 = true;
    this.dbe_1 = null;
  }
  kbe(_set____db54di) {
    this.cbe_1 = _set____db54di;
  }
  lbe(value) {
    this.cbe_1 = false;
    this.dbe_1 = value;
  }
  bbe(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.lbe(sourceFile);
    _this__u8e3s4.kbe(true);
  }
  ibe(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.ud('An operation is not implemented: ' + reason);
  }
  hbe(ctx, view) {
    if (this.cbe_1)
      return Unit_instance;
    this.qbx(ctx, view);
  }
  qbx(ctx, view) {
    if (!this.cbe_1 && !(this.dbe_1 == null)) {
      this.cbe_1 = true;
      launchImmediately_0(ctx.j86_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.rbx_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static e9x(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().j8d_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.t6d();
    $this.e9p_1 = new Mixin();
    $this.f9p_1 = coroutineContext;
    $this.g9p_1 = ag;
    $this.h9p_1 = injector;
    $this.i9p_1 = input;
    $this.j9p_1 = timeProvider;
    $this.k9p_1 = stats;
    $this.l9p_1 = gameWindow;
    $this.m9p_1 = gameId;
    $this.n9p_1 = settingsFolder;
    $this.o9p_1 = batchMaxQuads;
    $this.p9p_1 = bp;
    $this.q9p_1 = stageBuilder;
    $this.r9p_1 = quality$factory($this.l9p_1);
    $this.s9p_1 = $this;
    $this.t9p_1 = false;
    $this.u9p_1 = continuousRenderMode$factory($this.l9p_1);
    $this.v9p_1 = new ReshapeEvent(0, 0);
    $this.w9p_1 = new UpdateEvent();
    $this.x9p_1 = new ViewsUpdateEvent($this);
    $this.y9p_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.z9p_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.b9q_1 = null;
    $this.c9q_1 = get_resourcesVfs();
    $this.d9q_1 = get_RegisteredImageFormats();
    $this.e9q_1 = new RenderContext($this.g9p_1, $this, $this.l9p_1, $this.k9p_1, $this.f9p_1, $this.o9p_1, $this.l9p_1);
    $this.f9q_1 = true;
    $this.g9q_1 = Colors_getInstance().i3z_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.h9q_1 = HashMap.m8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.i9q_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.j9q_1 = new Resources($this.f9p_1, $this.c9q_1);
    $this.k9q_1 = false;
    $this.l9q_1 = 1280;
    $this.m9q_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.n9q_1 = ArrayList.i1();
    $this.o9q_1 = Companion_getInstance_24().d2j_1;
    $this.p9q_1 = Companion_getInstance_25().c28_1;
    $this.q9q_1 = true;
    $this.r9q_1 = $this.q9p_1($this);
    $this.s9q_1 = $this.r9q_1;
    $this.t9q_1 = true;
    $this.u9q_1 = false;
    $this.v9q_1 = debugExtraFontScale$factory($this.e9q_1);
    $this.w9q_1 = debugExtraFontColor$factory($this.e9q_1);
    $this.x9q_1 = FastArrayList.uz();
    $this.y9q_1 = $this.j9p_1.p1w();
    var tmp_4 = $this;
    tmp_4.z9q_1 = Pool.d2t(VOID, Views$tempViewsPool$lambda);
    $this.a9r_1 = SizeInt.r2j();
    $this.b9r_1 = SizeInt.r2j();
    $this.c9r_1 = SizeInt.r2j();
    $this.d9r_1 = new Signal();
    $this.e9r_1 = new Signal();
    $this.f9r_1 = -1.0;
    $this.h9p_1.a6b(getKClass(CoroutineContext), $this.f9p_1);
    $this.h9p_1.a6b(getKClass(AG), $this.g9p_1);
    $this.h9p_1.a6b(getKClass(Views), $this);
    $this.e9r_1.t1z(Views$lambda($this));
    $this.d9r_1.t1z(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.g9r_1 = Companion_instance_11.ei('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.h9r_1 = new EventResult();
    $this.i9r_1 = new Signal();
    $this.j9r_1 = Companion_getInstance_0().tx('debugHightlightView');
    $this.k9r_1 = new Signal();
    $this.l9r_1 = new Signal();
    $this.m9r_1 = ArrayList.i1();
    $this.n9r_1 = updatedSinceFrame$factory($this.l9p_1);
    return $this;
  }
  b16() {
    return this.f9p_1;
  }
  ka0() {
    return this.s9p_1;
  }
  p9x(_set____db54di) {
    var this_0 = this.u9p_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  j9x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u9p_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  a3() {
    return this.i9p_1.z89_1;
  }
  tbx() {
    return replace(replace(replace(this.m9p_1, '\\', ''), '/', ''), '..', '');
  }
  o9y() {
    var tmp = this.a9q_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  q26($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  o9x() {
    return this.j9q_1;
  }
  q9x() {
    return this.g9p_1.s6m().l6m_1;
  }
  r9x() {
    return this.g9p_1.s6m().m6m_1;
  }
  ubx(value) {
    this.l9q_1 = numberToInt(value);
  }
  vbx() {
    return this.l9q_1;
  }
  wbx(value) {
    this.m9q_1 = numberToInt(value);
  }
  xbx() {
    return this.m9q_1;
  }
  ubs(value) {
    this.ubx(value.c2a_1);
    this.wbx(value.d2a_1);
  }
  tbs() {
    return Size2D.h2h(this.vbx(), this.xbx());
  }
  g6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  sbx($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  j9y() {
    return this.r9q_1.l8a();
  }
  f9x(_set____db54di) {
    var this_0 = this.v9q_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ybx() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v9q_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  g9x(_set____db54di) {
    var this_0 = this.w9q_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  zbx() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w9q_1;
    debugFontColor$factory_0();
    return this_0.get().d4f_1;
  }
  kb5(block) {
    this.x9q_1.h(block);
  }
  x6d(type, event, result, up, down) {
    event.q6e(false);
    var result_0 = super.x6d(type, event, result, up, down);
    var e = event;
    e.p6e(this.s9p_1);
    if (e instanceof KeyEvent) {
      this.i9p_1.s8a(e);
      this.i9p_1.z89_1.j89(e);
      if (e.l6f_1.equals(Type_UP_getInstance_0()) && this.t9q_1 && (e.n6f_1.equals(Key_F12_getInstance()) || e.n6f_1.equals(Key_F7_getInstance()))) {
        this.u9q_1 = !this.u9q_1;
        this.l9p_1.i8p(this.u9q_1);
        this.bag(this.r9q_1);
      }
    }
    try {
      return this.r9q_1.g6e(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  aby(frameBuffer) {
    this.e9q_1.i87_1 = frameBuffer;
    if (this.f9q_1) {
      var tmp0_$this = this.e9q_1;
      var tmp1_color = this.g9q_1;
      tmp0_$this.i8h(tmp1_color, 1.0, 0, true, true, true);
    }
    this.d9r_1.u1z(this.e9q_1);
    this.e9q_1.r88();
    this.r9q_1.fad(this.e9q_1);
    this.e9q_1.r88();
    this.r9q_1.nag(this.e9q_1);
    if (this.u9q_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.x9q_1.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.e9q_1);
      }
    }
    this.e9r_1.u1z(this.e9q_1);
    this.e9q_1.r88();
  }
  bby(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.g9p_1.s6m() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.aby(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.aby.call(this, frameBuffer);
    }
    return tmp;
  }
  cby() {
    this.g9p_1.w6m();
    this.bby();
  }
  k9x(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.j9p_1.p1w();
    this.s9p_1.k9p_1.w6m();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.y9q_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.s9p_1.i9q_1) > 0 ? this.s9p_1.i9q_1 : delta;
    this.y9q_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.v1w())) {
        this.eby(fixedSizeStep);
      } else {
        this.dby(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.fby() > 0);
    if (doRender2) {
      if (this.g9r_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().r1w().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.fby() + ']');
      }
      this.cby();
      this.w6m();
    }
  }
  dby(elapsed) {
    return this.eby(get_fast(elapsed));
  }
  eby(elapsed) {
    this.i9p_1.q8a(elapsed);
    this.h9r_1.v2t();
    updateSingleViewWithViewsAll(this.r9q_1, this, elapsed);
    this.i9p_1.r8a(elapsed);
  }
  i9x() {
  }
  n9x(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.b9r_1 = SizeInt.q2j(actualWidth, actualHeight);
    this.gby();
  }
  gby() {
    setBoundsInfo(this.p9p_1, Size2D.e2a(this.l9q_1, this.m9q_1), toFloat(this.b9r_1), this.o9q_1, this.p9q_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.e9q_1.p86_1 = this.p9p_1.u8f();
    this.e9q_1.q86_1 = this.p9p_1.q8f();
    // Inline function 'kotlin.also' call
    var this_0 = this.v9p_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.f6f_1 = this.b9r_1.o2j_1;
    this_0.g6f_1 = this.b9r_1.p2j_1;
    this.g6e(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.y9p_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.kby_1 = this.a9r_1;
    this.g6e(this_1);
    this.r9q_1.dag();
  }
  lby(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.l9p_1.j8p())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.j9r_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.i9r_1.u1z(viewToHightlight);
  }
  m9y(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.lby(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.lby.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  mby(_set____db54di) {
    var this_0 = this.n9r_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  fby() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n9r_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  w6m() {
    this.l9p_1.w6m();
  }
  bag(view) {
    this.l9p_1.x8p();
  }
  cz(value) {
    this.e9p_1.cz(value);
  }
  dz() {
    return this.e9p_1.dz();
  }
  a8g(pos) {
    return this.p9p_1.a8g(pos);
  }
  p8f(value) {
    this.p9p_1.p8f(value);
  }
  q8f() {
    return this.p9p_1.q8f();
  }
  r8f(value) {
    this.p9p_1.r8f(value);
  }
  s8f() {
    return this.p9p_1.s8f();
  }
  t8f(value) {
    this.p9p_1.t8f(value);
  }
  u8f() {
    return this.p9p_1.u8f();
  }
  v8f(value) {
    this.p9p_1.v8f(value);
  }
  w8f() {
    return this.p9p_1.w8f();
  }
  x8f(value) {
    this.p9p_1.x8f(value);
  }
  y8f() {
    return this.p9p_1.y8f();
  }
  z8f() {
    return this.p9p_1.z8f();
  }
  s8h() {
    return this.l9p_1.s8h();
  }
  t8h() {
    return this.l9p_1.t8h();
  }
  u8h() {
    return this.l9p_1.u8h();
  }
  d8h() {
    return this.l9p_1.d8h();
  }
}
class Companion_11 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.u1w() : fastDelta;
    super();
    this.kbx_1 = views;
    this.lbx_1 = fastDelta;
  }
  mbx() {
    return toDuration_0(this.lbx_1);
  }
  v2c() {
    return Companion_instance_26;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.lbx_1) + ')';
  }
}
class Companion_12 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.q2j(0, 0) : size;
    super();
    this.jby_1 = views;
    this.kby_1 = size;
  }
  v2c() {
    return Companion_instance_27;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.kby_1.toString() + ')';
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.nby_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  oby(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.nby_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_32().v2b_1;
}
class RenderToTextureResult {
  constructor() {
    this.sby_1 = null;
    this.tby_1 = 0;
    this.uby_1 = 0;
    this.vby_1 = 0;
    this.wby_1 = 0;
    this.xby_1 = 1.0;
    this.yby_1 = Companion_getInstance_30().f2c_1;
    this.zby_1 = null;
    this.abz_1 = null;
    this.bbz_1 = null;
    this.cbz_1 = null;
  }
  m19() {
    if (this.abz_1 == null || this.cbz_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.abz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.cbz_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.o8h(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.sby_1 = null;
    this.zby_1 = null;
    this.abz_1 = null;
    this.cbz_1 = null;
    this.bbz_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_51();
    this.dbz_1 = smoothing;
  }
  rby(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d87_1;
    var this_1 = this_0.m87_1;
    if (!(this_1.h87_1 === this_0)) {
      this_1.h87_1 = this_0;
      this_1.r88();
    }
    this_0.t88(texture, VOID, VOID, VOID, VOID, matrix, this.dbz_1, renderColorMul, blendMode, Companion_getInstance_6().q8d_1);
  }
}
class Companion_14 extends IdentityFilter {
  constructor() {
    Companion_instance_29 = null;
    super(true);
    Companion_instance_29 = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class ViewRenderPhaseFilter {}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.qc0_1 = bounds;
    this.rc0_1 = vertexCount;
    this.sc0_1 = vertexStart;
    this.tc0_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static hbb(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ib5();
    $this.iba_1 = autoScaling;
    $this.jba_1 = true;
    $this.kba_1 = true;
    $this.lba_1 = true;
    $this.mba_1 = new GpuShapeViewCommands();
    $this.nba_1 = 1000;
    $this.oba_1 = 1000;
    $this.pba_1 = Companion_getInstance_25().y27_1;
    $this.qba_1 = true;
    $this.rba_1 = false;
    $this.sba_1 = antialiased;
    $this.tba_1 = shape;
    $this.uba_1 = false;
    $this.vba_1 = false;
    $this.wba_1 = false;
    $this.xba_1 = 0;
    $this.yba_1 = Companion_getInstance_28().i2c();
    $this.zba_1 = Companion_getInstance_28().i2c();
    $this.abb_1 = false;
    $this.bbb_1 = 1.0;
    $this.cbb_1 = NaN;
    $this.dbb_1 = Companion_getInstance_30().i2c();
    $this.ebb_1 = 100000;
    $this.fbb_1 = false;
    $this.gbb_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  naw(value) {
    this.lba_1 = value;
    this.kai();
  }
  gao(value) {
    this.pba_1 = value;
    this.dag();
  }
  kaw() {
    return this.pba_1;
  }
  jbb(value) {
    this.sba_1 = value;
    invalidateShape(this);
  }
  ibb(value) {
    this.tba_1 = value;
    invalidateShape(this);
  }
  vag() {
    return _get_shapeBounds__actvvf(this).j29_1 * this.kaw().h28_1;
  }
  wag() {
    return _get_shapeBounds__actvvf(this).k29_1 * this.kaw().i28_1;
  }
  dag() {
    super.dag();
    invalidateShape(this);
  }
  gad() {
    return new Rectangle(_get_shapeBounds__actvvf(this).h29_1 - this.vag(), _get_shapeBounds__actvvf(this).i29_1 - this.wag(), _get_shapeBounds__actvvf(this).j29_1, _get_shapeBounds__actvvf(this).k29_1);
  }
  vc0(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.b5o_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.g1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.vc0(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.vc0(_this__u8e3s4.u5o());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.z5n();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  jad(ctx) {
    this.bbb_1 = this.n9y().s2d().q2e() * ctx.g86_1.z8f();
    if (!(this.cbb_1 === this.bbb_1)) {
      invalidateShape(this);
    }
    ctx.r88();
    var doRequireTexture = this.vc0(this.tba_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.hj();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.f86_1.s6m();
      this.nba_1 = currentFrameBuffer.l6m_1;
      this.oba_1 = currentFrameBuffer.m6m_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.nba_1;
      var height = this.oba_1;
      ctx.r88();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.n8h(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.p8h(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.d87_1;
          var this_1 = this_0.m87_1;
          if (!(this_1.h87_1 === this_0)) {
            this_1.h87_1 = this_0;
            this_1.r88();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.i6x(0, 0, rb.l6m_1, rb.m6m_1);
            var temp = this_0.k88_1;
            this_0.u8e();
            this_0.k88_1 = scissor;
            try {
              if (true) {
                ctx.i8h(Colors_getInstance().m3z_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.u8e();
              this_0.k88_1 = temp;
            }
          }
        }finally {
          ctx.q8h();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).h3k(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.d87_1;
        var this_3 = this_2.m87_1;
        if (!(this_3.h87_1 === this_2)) {
          this_3.h87_1 = this_2;
          this_3.r88();
        }
        this_2.t88(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.g86_1.q8f()));
        ctx.r88();
      }finally {
        ctx.o8h(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.wc0_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.wc0_1.toString() + ')';
  }
  hashCode() {
    return this.wc0_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.wc0_1.equals(tmp0_other_with_cast.wc0_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.xc0_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.xc0_1 + ')';
  }
  hashCode() {
    return this.xc0_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.xc0_1 === tmp0_other_with_cast.xc0_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_16().c6w_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_22().v6n_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().s6n_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().q6n_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().g6o_1 : cullFace;
    this.yc0_1 = drawType;
    this.zc0_1 = vertexIndex;
    this.ac1_1 = vertexEnd;
    this.bc1_1 = paintShader;
    this.cc1_1 = program;
    this.dc1_1 = colorMask;
    this.ec1_1 = stencilOpFunc;
    this.fc1_1 = stencilRef;
    this.gc1_1 = blendMode;
    this.hc1_1 = cullFace;
  }
  c8e() {
    return this.ac1_1 - this.zc0_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.yc0_1) + ', vertexIndex=' + this.zc0_1 + ', vertexEnd=' + this.ac1_1 + ', paintShader=' + toString_0(this.bc1_1) + ', program=' + toString_0(this.cc1_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.dc1_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.ec1_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.fc1_1) + ', blendMode=' + toString_0(this.gc1_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.hc1_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.yc0_1);
    result = imul(result, 31) + this.zc0_1 | 0;
    result = imul(result, 31) + this.ac1_1 | 0;
    result = imul(result, 31) + (this.bc1_1 == null ? 0 : this.bc1_1.hashCode()) | 0;
    result = imul(result, 31) + (this.cc1_1 == null ? 0 : this.cc1_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.dc1_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.ec1_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.fc1_1) | 0;
    result = imul(result, 31) + (this.gc1_1 == null ? 0 : this.gc1_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.hc1_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.yc0_1 === tmp0_other_with_cast.yc0_1))
      return false;
    if (!(this.zc0_1 === tmp0_other_with_cast.zc0_1))
      return false;
    if (!(this.ac1_1 === tmp0_other_with_cast.ac1_1))
      return false;
    if (!equals(this.bc1_1, tmp0_other_with_cast.bc1_1))
      return false;
    if (!equals(this.cc1_1, tmp0_other_with_cast.cc1_1))
      return false;
    if (!(this.dc1_1 === tmp0_other_with_cast.dc1_1))
      return false;
    if (!(this.ec1_1 === tmp0_other_with_cast.ec1_1))
      return false;
    if (!equals(this.fc1_1, tmp0_other_with_cast.fc1_1))
      return false;
    if (!equals(this.gc1_1, tmp0_other_with_cast.gc1_1))
      return false;
    if (!(this.hc1_1 === tmp0_other_with_cast.hc1_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.gbz_1 = 0;
    this.hbz_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ibz_1 = ArrayList.i1();
    this.jbz_1 = null;
    this.kbz_1 = FastArrayList.uz();
    this.lbz_1 = 0;
    this.mbz_1 = 0;
    this.nbz_1 = MatrixTransform.o2e();
    this.obz_1 = FastArrayList.uz();
    this.pbz_1 = AGTextureUnits.d6q();
  }
  e3() {
    this.gbz_1 = 0;
    this.hbz_1.e3();
    this.ibz_1.e3();
  }
  ubz(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.lbz_1;
      this.lbz_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.hbz_1.l2n(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.gbz_1;
    this.gbz_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  tbz() {
    this.mbz_1 = this.gbz_1;
    return this.mbz_1;
  }
  vbz() {
    return this.gbz_1;
  }
  uc0(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.ibz_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  pc0(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_22().v6n_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().s6n_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().q6n_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().k85_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().g6o_1 : cullFace;
    startIndex = startIndex === VOID ? this.mbz_1 : startIndex;
    endIndex = endIndex === VOID ? this.gbz_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.uc0(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.uc0.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  o7c(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.ibz_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  qbz(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.o7c(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.o7c.call(this, i);
    }
    return tmp;
  }
  rbz(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.ibz_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  u6m() {
    var tmp0_safe_receiver = this.jbz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.kbz_1.h(tmp0_safe_receiver);
    }
    this.jbz_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.hbz_1.q2n())));
  }
  sbz(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.jbz_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.z86_1.g8d(this.kbz_1);
    this.kbz_1.e3();
    ctx.r88();
    var ag = ctx.f86_1;
    var vao = AGVertexArrayObject.n6v(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().fc0_1, ctx.d8d(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.d87_1;
    var this_1 = this_0.m87_1;
    if (!(this_1.h87_1 === this_0)) {
      this_1.h87_1 = this_0;
      this_1.r88();
    }
    this_0.d8f();
    var tempMat = (doRequireTexture ? Companion_getInstance_30().f2c_1 : this_0.a8e()).q2d(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.m87_1;
    this_2.r88();
    var temp4 = this_2.s86_1;
    var temp2d = this_2.t86_1;
    this_2.t86_1 = tempMat;
    this_2.s86_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.u6t(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.j6v();
      this_3.a7i(_unary__edvuaz + 1 | 0);
      this_3.b7i(this_3.j6v() + 1 | 0);
      var blockSize = this_3.n6t_1;
      var index0 = imul(this_3.j6v() - 1 | 0, blockSize);
      var index1 = imul(this_3.j6v(), blockSize);
      var texBlockSize = this_3.k6t_1.j71().e1();
      var texIndex0 = imul(this_3.j6v() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.j6v(), texBlockSize);
      if (this_3.j6v() > 0) {
        arraycopy(this_3.p6t_1, index0, this_3.p6t_1, index1, blockSize);
      } else {
        arrayfill(this_3.p6t_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.k6t_1;
      this_3.q6t_1.k7i($this$push.i71(), this_2.s86_1);
      if (true && this_3.j6v() >= 1) {
        var equals = arrayequal(this_3.p6t_1, index0, this_3.p6t_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.j6v();
          this_3.a7i(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.nbz_1 = globalMatrix.s2d();
      var program = GpuShapeViewPrograms_getInstance().mc0_1;
      var scissor = Companion_getInstance_14().e6o_1;
      var this_4 = this.ibz_1;
      var n = 0;
      while (n < this_4.e1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.d1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.wc0_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.xc0_1;
            ctx.i8h(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.bc1_1;
              this_0.j8f(cmd.c8e());
              var pixelScale = this.nbz_1.q2e() / ctx.g86_1.z8f();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.m87_1.u6t(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.j6v();
                  this_5.a7i(_unary__edvuaz_2 + 1 | 0);
                  this_5.b7i(this_5.j6v() + 1 | 0);
                  var blockSize_0 = this_5.n6t_1;
                  var index0_0 = imul(this_5.j6v() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.j6v(), blockSize_0);
                  var texBlockSize_0 = this_5.k6t_1.j71().e1();
                  var texIndex0_0 = imul(this_5.j6v() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.j6v(), texBlockSize_0);
                  if (this_5.j6v() > 0) {
                    arraycopy(this_5.p6t_1, index0_0, this_5.p6t_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.p6t_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.k6t_1;
                  var it = this_5.q6t_1;
                  it.e7i(paintShader.ic1_1);
                  it.f7i($this$push_0.xc1(), pixelScale);
                  it.h7i($this$push_0.yc1(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.j6v() >= 1) {
                    var equals_0 = arrayequal(this_5.p6t_1, index0_0, this_5.p6t_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.j6v();
                      this_5.a7i(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.jc1_1 == null)) {
                  var tex = ctx.v86_1.f2t();
                  tex.b6s(paintShader.jc1_1);
                  this.pbz_1.u6q(DefaultShaders_getInstance().c74(), tex);
                  this.obz_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.cc1_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.i87_1.e6m_1;
              var tmp5_frameBufferInfo = ctx.i87_1.k6o();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.z8g(_program);
              var tmp8_textureUnits = this.pbz_1.zy();
              var tmp9_stencilOpFunc = cmd.ec1_1;
              var tmp10_stencilRef = cmd.fc1_1;
              var tmp11_colorMask = cmd.dc1_1;
              var tmp3_elvis_lhs = cmd.gc1_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().k85_1 : tmp3_elvis_lhs).u88_1;
              var tmp13_cullFace = cmd.hc1_1;
              var tmp14_drawType = cmd.yc0_1;
              var tmp15_drawOffset = cmd.zc0_1;
              var tmp16_vertexCount = cmd.c8e();
              draw(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.r88();
      this_2.s86_1 = temp4;
      this_2.t86_1 = temp2d;
      this_2.u6t(ProjViewUB_getInstance()).c7i();
    }
    var _iterator__ex2g4s = this.obz_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var tex_0 = _iterator__ex2g4s.c1();
      ctx.v86_1.g2t(tex_0);
    }
    this.obz_1.e3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.pc1_1 = this.o71().g71(this, u_ProgramType$factory());
    this.qc1_1 = this.q71().g71(this, u_Color$factory());
    this.rc1_1 = this.q71().g71(this, u_ColorMul$factory());
    this.sc1_1 = this.o71().g71(this, u_GlobalAlpha$factory());
    this.tc1_1 = this.o71().g71(this, u_GlobalPixelScale$factory());
    this.uc1_1 = this.w70().g71(this, u_Transform$factory());
    this.vc1_1 = this.q71().g71(this, u_Gradientp0$factory());
    this.wc1_1 = this.q71().g71(this, u_Gradientp1$factory());
  }
  zc1() {
    return this.pc1_1.ho(this, u_ProgramType$factory_0());
  }
  ac2() {
    return this.qc1_1.ho(this, u_Color$factory_0());
  }
  yc1() {
    return this.rc1_1.ho(this, u_ColorMul$factory_0());
  }
  bc2() {
    return this.sc1_1.ho(this, u_GlobalAlpha$factory_0());
  }
  xc1() {
    return this.tc1_1.ho(this, u_GlobalPixelScale$factory_0());
  }
  cc2() {
    return this.uc1_1.ho(this, u_Transform$factory_0());
  }
  dc2() {
    return this.vc1_1.ho(this, u_Gradientp0$factory_0());
  }
  ec2() {
    return this.wc1_1.ho(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().mc0_1 : program;
    this.ic1_1 = uniforms;
    this.jc1_1 = texture;
    this.kc1_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.ic1_1.toString() + ', texture=' + toString_0(this.jc1_1) + ', program=' + this.kc1_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.ic1_1);
    result = imul(result, 31) + (this.jc1_1 == null ? 0 : hashCode(this.jc1_1)) | 0;
    result = imul(result, 31) + this.kc1_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.ic1_1, tmp0_other_with_cast.ic1_1))
      return false;
    if (!equals(this.jc1_1, tmp0_other_with_cast.jc1_1))
      return false;
    if (!this.kc1_1.equals(tmp0_other_with_cast.kc1_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.wbz_1 = Attribute.m72('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.xbz_1 = Attribute.m72('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.ybz_1 = Varying.y72('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.zbz_1 = Varying.y72('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.ac0_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1]);
    this.bc0_1 = ProgramLayout.x6v([DefaultShaders_getInstance().i6z_1]);
    this.cc0_1 = ProgramLayout.x6v([this.xbz_1]);
    this.dc0_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1, DefaultShaders_getInstance().i6z_1]);
    this.ec0_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1, this.xbz_1]);
    this.fc0_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1, this.xbz_1, this.wbz_1]);
    this.gc0_1 = 0;
    this.hc0_1 = 1;
    this.ic0_1 = 2;
    this.jc0_1 = 3;
    this.kc0_1 = 4;
    this.lc0_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.s73(this_0.v73(), this_0.w73(this_0.w73(this_0.h71(), this_0.i71()), this_0.z73([this_0.x73(), this_0.y73(0.0), this_0.y73(1.0)])));
    this_0.s73(this_0.o73(), DefaultShaders_getInstance().h6z_1);
    this_0.s73(GpuShapeViewPrograms_getInstance().zbz_1, GpuShapeViewPrograms_getInstance().xbz_1);
    this_0.s73(GpuShapeViewPrograms_getInstance().ybz_1, GpuShapeViewPrograms_getInstance().wbz_1);
    var tmp0_vertex = VertexShader(this_0.a74());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.t75(GpuShapeViewPrograms_getInstance().zc1(), this_1.y73(5));
    var body = this_1.j74();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.s73(body.v73(), body.z73([body.y73(1.0), body.y73(0.0), body.y73(0.0), body.y73(1.0)]));
    body.c75();
    var stmIf = new If(cond, body.l74());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.r73_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.w75(this_1.i75(GpuShapeViewPrograms_getInstance().zbz_1), GpuShapeViewPrograms_getInstance().ybz_1);
    var body_0 = this_1.j74();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.a75();
    var stmIf_0 = new If(cond_0, body_0.l74());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.r73_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().zc1();
    this_1.z74(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.r75(this_1.y73(1.0), this_1.k75(this_1.r75(this_1.w73(GpuShapeViewPrograms_getInstance().ybz_1, GpuShapeViewPrograms_getInstance().xc1()), this_1.y73(1.5)), this_1.w73(GpuShapeViewPrograms_getInstance().ybz_1, GpuShapeViewPrograms_getInstance().xc1()), this_1.i75(this_1.w73(GpuShapeViewPrograms_getInstance().zbz_1, GpuShapeViewPrograms_getInstance().xc1()))));
    this_1.s73(this_1.v73(), this_1.w73(this_1.w73(this_1.w73(this_1.v73(), GpuShapeViewPrograms_getInstance().yc1()), GpuShapeViewPrograms_getInstance().bc2()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.a74());
    tmp.mc0_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.v2t();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.j6v();
      this_2.a7i(_unary__edvuaz + 1 | 0);
      this_2.b7i(this_2.j6v() + 1 | 0);
      var blockSize = this_2.n6t_1;
      var index0 = imul(this_2.j6v() - 1 | 0, blockSize);
      var index1 = imul(this_2.j6v(), blockSize);
      var texBlockSize = this_2.k6t_1.j71().e1();
      var texIndex0 = imul(this_2.j6v() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.j6v(), texBlockSize);
      if (this_2.j6v() > 0) {
        arraycopy(this_2.p6t_1, index0, this_2.p6t_1, index1, blockSize);
      } else {
        arrayfill(this_2.p6t_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.k6t_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.q6t_1.g7i(ShapeViewUB_getInstance().zc1(), 5);
      if (true && this_2.j6v() >= 1) {
        var equals = arrayequal(this_2.p6t_1, index0, this_2.p6t_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.j6v();
          this_2.a7i(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.nc0_1 = new PaintShader(this_2, null);
  }
  zc1() {
    return ShapeViewUB_getInstance().zc1().d6v_1;
  }
  ac2() {
    return ShapeViewUB_getInstance().ac2().d6v_1;
  }
  yc1() {
    return ShapeViewUB_getInstance().yc1().d6v_1;
  }
  bc2() {
    return ShapeViewUB_getInstance().bc2().d6v_1;
  }
  xc1() {
    return ShapeViewUB_getInstance().xc1().d6v_1;
  }
  cc2() {
    return ShapeViewUB_getInstance().cc2().d6v_1;
  }
  dc2() {
    return ShapeViewUB_getInstance().dc2().d6v_1;
  }
  ec2() {
    return ShapeViewUB_getInstance().ec2().d6v_1;
  }
  fc2(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_23().n7o_1;
    return $this$ExpressionBuilder.g75(_this__u8e3s4, $this$ExpressionBuilder.y73(2.0));
  }
  oc0(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.v2t();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.j6v();
          this_0.a7i(_unary__edvuaz + 1 | 0);
          this_0.b7i(this_0.j6v() + 1 | 0);
          var blockSize = this_0.n6t_1;
          var index0 = imul(this_0.j6v() - 1 | 0, blockSize);
          var index1 = imul(this_0.j6v(), blockSize);
          var texBlockSize = this_0.k6t_1.j71().e1();
          var texIndex0 = imul(this_0.j6v() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.j6v(), texBlockSize);
          if (this_0.j6v() > 0) {
            arraycopy(this_0.p6t_1, index0, this_0.p6t_1, index1, blockSize);
          } else {
            arrayfill(this_0.p6t_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.k6t_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.q6t_1;
          it.g7i($this$push.zc1(), 0);
          it.h7i($this$push.ac2(), _RGBA___get_premultiplied__impl__3bulqc(paint.d4f_1));
          it.g7i($this$push.bc2(), globalAlpha);
          if (true && this_0.j6v() >= 1) {
            var equals = arrayequal(this_0.p6t_1, index0, this_0.p6t_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.j6v();
              this_0.a7i(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_30().f2c_1.x2d(paint.k5g_1).x2d(stateTransform).r2d().f2d(1.0 / paint.j5g_1.a3y_1, 1.0 / paint.j5g_1.b3y_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.v2t();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.j6v();
            this_1.a7i(_unary__edvuaz_1 + 1 | 0);
            this_1.b7i(this_1.j6v() + 1 | 0);
            var blockSize_0 = this_1.n6t_1;
            var index0_0 = imul(this_1.j6v() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.j6v(), blockSize_0);
            var texBlockSize_0 = this_1.k6t_1.j71().e1();
            var texIndex0_0 = imul(this_1.j6v() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.j6v(), texBlockSize_0);
            if (this_1.j6v() > 0) {
              arraycopy(this_1.p6t_1, index0_0, this_1.p6t_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.p6t_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.k6t_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.q6t_1;
            it_0.g7i($this$push_0.zc1(), 1);
            it_0.k7i($this$push_0.cc2(), toMatrix4(mat));
            it_0.g7i($this$push_0.bc2(), globalAlpha);
            if (true && this_1.j6v() >= 1) {
              var equals_0 = arrayequal(this_1.p6t_1, index0_0, this_1.p6t_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.j6v();
                this_1.a7i(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.j5g_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.t3x(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.e3y_1;
            if (true) {
              gradientBitmap.n3y();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.v5f(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.q3x_1));
            }finally {
              result = true ? gradientBitmap.p3y(rect) : 0;
            }
            var npaint = paint.w5f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_30().f2c_1.x2d(paint.r53_1).x2d(stateTransform));
            var mat_0 = paint.h53_1.k3_1 === 0 ? npaint.x53_1 : npaint.r53_1.r2d();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.v2t();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.j6v();
              this_2.a7i(_unary__edvuaz_3 + 1 | 0);
              this_2.b7i(this_2.j6v() + 1 | 0);
              var blockSize_1 = this_2.n6t_1;
              var index0_1 = imul(this_2.j6v() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.j6v(), blockSize_1);
              var texBlockSize_1 = this_2.k6t_1.j71().e1();
              var texIndex0_1 = imul(this_2.j6v() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.j6v(), texBlockSize_1);
              if (this_2.j6v() > 0) {
                arraycopy(this_2.p6t_1, index0_1, this_2.p6t_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.p6t_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.k6t_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.q6t_1;
              var tmp_0 = $this$push_1.zc1();
              var tmp0 = paint.h53_1.k3_1;
              it_1.g7i(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.k7i($this$push_1.cc2(), toMatrix4(mat_0));
              it_1.j7i($this$push_1.dc2(), new Vector4F(paint.i53_1, paint.j53_1, paint.k53_1, 1.0));
              it_1.j7i($this$push_1.ec2(), new Vector4F(paint.l53_1, paint.m53_1, paint.n53_1, 1.0));
              it_1.g7i($this$push_1.bc2(), globalAlpha);
              if (true && this_2.j6v() >= 1) {
                var equals_1 = arrayequal(this_2.p6t_1, index0_1, this_2.p6t_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.j6v();
                  this_2.a7i(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.ud('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.x9l($this.m9k_1.w9l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.n9k_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_36() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().h1z($this.t9l_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9m(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.q9o(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.h1p($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_37() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.o9r_1.r9k_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.p9r_1.r9q_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_26().k2j_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.il();
    var height = size.jl();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.k2l();
      rwidth = tmp1_elvis_lhs == null ? views_0.r9q_1.k2l() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.l2l();
      rheight = tmp3_elvis_lhs == null ? views_0.r9q_1.l2l() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.s9w(views_0, defaultTransition, name, Size2D.h2h(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).t9w($this.o9r_1.r9k_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.q9r_1($this.p9r_1.r9q_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.o9r_1.z9k_1) {
    var tmp_3 = $this.r9r_1.o8p($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.u9w_1, $this.v9w_1, $this.w9w_1, $this.x9w_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.h1p($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_35().mv()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().u6b();
    try {
      var tmp0_elvis_lhs = $this.a9x_1.h9l_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().i3z_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.y9w_1, $this.z9w_1, $this.a9x_1.g9l_1, null, $this.a9x_1.y9k_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().u6b();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.a8p(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().u6b();
    try {
      try {
        if (!($this.b9x_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().ei($this.b9x_1), $this.c9x_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.c8p(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_36().y9l_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.d2x(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.e2x(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().u6b();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.a8p('setIcon', tmp$ret$5);
    }
  }
  $this$loop.h8p($this$loop.a8h());
  if (Companion_getInstance_35().mv()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.sc();
  var this_3 = Views.e9x(tmp$ret$6.ym(gameWindow.v8o()).ym(new InjectorContext($this.a9x_1.t9k_1)).ym(SupervisorJob()).ym(CoroutineName.x1c('Views')), $this.a9x_1.o9l_1 ? AGPrint.g7g() : $this$loop.u8o(), $this.a9x_1.t9k_1, input, $this.a9x_1.s9k_1, stats, gameWindow, $this.a9x_1.a9l_1, $this.a9x_1.b9l_1, $this.a9x_1.c9l_1, VOID, $this.a9x_1.r9l_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.q26($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_35().rv()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.s30(), 'views', this_3);
  }
  var views = this_3;
  $this.a9x_1.t9k_1.a6b(getKClass(GameWindow), gameWindow);
  $this.a9x_1.t9k_1.a6b(getKClass(Korge), $this.a9x_1);
  views.u9q_1 = $this$loop.j8p();
  views.f9x($this.a9x_1.p9l_1);
  views.g9x($this.a9x_1.q9l_1);
  views.l9q_1 = numberToInt($this.a9x_1.e9l_1.c2a_1);
  views.m9q_1 = numberToInt($this.a9x_1.e9l_1.d2a_1);
  views.p9q_1 = $this.a9x_1.f9l_1.y9o_1;
  views.o9q_1 = $this.a9x_1.f9l_1.x9o_1;
  views.q9q_1 = $this.a9x_1.f9l_1.z9o_1;
  views.f9r_1 = $this.a9x_1.s9l_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().u6b();
    try {
      KorgeReload_getInstance().i85(gameWindow);
      var tmp_4 = KorgeRunner_instance.h9x(views, gameWindow, true, $this$loop.g8p(), Companion_instance_1.v1w(), $this.a9x_1.l9l_1, $this.a9x_1.u9k_1).t18($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().u6b();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.a8p(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().u6b();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().u6b();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.a8p(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.a9x_1, views, $this.d9x_1, gameWindow));
  if ($this.a9x_1.z9k_1) {
    var tmp_5 = gameWindow.o8p($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.m8p();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().z38();
      if (get_workerImpl().a39()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().k5c([config.p9k_1]);
      var iconPath = config.j9l_1;
      var imageFormats = config.p9k_1;
      var entry = config.n9l_1;
      var windowSize = config.d9l_1;
      if (!Companion_getInstance_35().rv()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().ei('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.q9k_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.sc().fd(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.m9l_1.q8q(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.g9l_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.h9l_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().i3z_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.f8p(tmp_1);
      var tmp_3 = realGameWindow.p8p(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.a8g(Vector2D.d2b(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.n8a(button, true);
  input.m8a(p, false);
  input.m8a(p, true);
  $views.i9x();
  downPos._v = input.l8a();
  downTime._v = new DateTime(Companion_getInstance_5().p1w());
  input.x89_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.n8a(button, false);
  input.m8a(p, false);
  $views.i9x();
  upPos._v = $views.i9p_1.l8a();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.i9p_1.m8a(p, false);
  $views.i9p_1.x89_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.i9x();
  moveTime._v = new DateTime(Companion_getInstance_5().p1w());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.i9p_1.m8a(p, false);
  $views.i9x();
  moveTime._v = new DateTime(Companion_getInstance_5().p1w());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.e6i_1 = 0;
  mouseTouchEvent.h6i_1 = true;
  mouseTouchEvent.f6i_1 = Companion_getInstance_5().p1w();
  mouseTouchEvent.g6i_1 = false;
  mouseTouchEvent.p6i(type);
  mouseTouchEvent.u6i(button.v6l_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.q6i();
  $views.g6e(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.p6j_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.h8a_1[gamepad.q6j_1].y6j(gamepad);
  }
  input.o8a();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.k9x($fixedSizeStep, $views.j9x(), event.u6e_1, event.v6e_1);
    $views.i9p_1.w89_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.i9p_1.w89_1 = true;
      $views.i9p_1.x89_1 = false;
      $views.i9x();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_36().y9l_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.d2x(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.e2x(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.t9p_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.l9x($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.e6g_1, e.f6g_1, e.p6g_1);
    var tmp_0;
    switch (e.c6g_1.k3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.g6g_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.g6g_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.g6g_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.g6g_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.g6g_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.g6e(e);
    get_nativeSoundProvider().s2u(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.g6e(e);
    get_nativeSoundProvider().s2u(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.g6e(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.k8a(e);
    var ee = $input.p89_1;
    var _iterator__ex2g4s = ee.m6i().a1();
    while (_iterator__ex2g4s.b1()) {
      var t = _iterator__ex2g4s.c1();
      t.r6h_1 = prepareViewsBase$getRealXY($views, t.w6h(), t.x6h(), e.g6i_1);
    }
    $views.g6e(ee);
    var tmp_0;
    if (ee.n6i() === 1) {
      var start = ee.x6i();
      var end = ee.y6i();
      var t_0 = first(ee.m6i());
      var p = t_0.r6h_1;
      var x = t_0.w6h();
      var y = t_0.x6h();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.d6g_1 = 0;
      this_1.g6g_1 = button;
      this_1.h6g_1 = end ? 0 : 1 << button.v6l_1;
      this_1.e6g_1 = numberToInt(x);
      this_1.f6g_1 = numberToInt(y);
      this_1.p6g_1 = false;
      this_1.q6g_1 = true;
      this_1.c6g_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.g6e(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().y9l_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.g6e(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.n9x($ag.s6m().l6m_1, $ag.s6m().m6m_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.g6e(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.v6e_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.e9q_1;
      var frameBuffer = this_0.s6m();
      this_0.m86_1.v2t();
      this_0.f86_1.w6m();
      var tmp_0;
      try {
        this_0.p8h(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.k1c(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.q8h();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.f86_1.q6i();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_36().z9l_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().j8d_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().v8a_1.c2a_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().v8a_1.d2a_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.e2a(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.c2a_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.d2a_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.e2a(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().d2j_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_25().k28() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().i3z_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().h3z_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).v9o(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9m(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.q9o(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.a9m(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.y9x_1.w9x_1.e20($this.z9x_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.a9y_1.u9x_1.e20($this.b9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.c9y_1.v9x_1.e20($this.d9y_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$justDown$lambda($keys, $callback, this$0, $ke) {
  return function ($this$addUpdaterWithViews, views, dt) {
    var vkeys = views.a3();
    var this_0 = $keys;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.input.KeysEvents.justDown.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var key = this_0.d1(_unary__edvuaz);
      if (vkeys.h89(key)) {
        $callback(this$0.e9y($ke, key, vkeys, dt.nj_1));
      }
    }
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6e_1;
    tmp.t9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.f9y().f9p_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6e_1;
    tmp.t9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.f9y().f9p_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.n6e_1;
    tmp.t9x_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.f9y().f9p_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.i9p_1)) {
    set_mouseHitSearch(views.i9p_1, true);
    set_mouseHitResult(views.i9p_1, views.r9q_1.k9y(views.j9y()));
    var view = get_mouseHitResult(views.i9p_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.h27();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.l9p_1.t8o(), newCursor)) {
      views.l9p_1.s8o(newCursor);
    }
  }
  return get_mouseHitResult(views.i9p_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.c8h();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.q8f();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_16, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.l9y();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.m9y(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.e9q_1.d87_1;
      var this_1 = this_0.m87_1;
      if (!(this_1.h87_1 === this_0)) {
        this_1.h87_1 = this_0;
        this_1.r88();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.s88(tmp$ret$1);
      var tmp1_x = bounds.h29_1;
      var tmp2_y = bounds.i29_1;
      var tmp3_width = bounds.j29_1;
      var tmp4_height = bounds.k29_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().j3z_1, 0.3);
      var tmp6_m = mouseHit.n9y();
      this_0.t88(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.e9q_1;
      var tmp8_font = _this__u8e3s4.o9y();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.j9y().x28_1 + ',' + $views.j9y().y28_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.c87_1;
      var tmp12_blendMode = Companion_getInstance_13().u85_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.i9p_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.l9y();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.e9q_1.d87_1;
      var this_3 = this_2.m87_1;
      if (!(this_3.h87_1 === this_2)) {
        this_3.h87_1 = this_2;
        this_3.r88();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.s88(tmp$ret$4);
      var tmp1_x_0 = bounds_0.h29_1;
      var tmp2_y_0 = bounds_0.i29_1;
      var tmp3_width_0 = bounds_0.j29_1;
      var tmp4_height_0 = bounds_0.k29_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().r4d(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.n9y();
      this_2.t88(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.e9q_1;
        var tmp8_font_0 = _this__u8e3s4.o9y();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.c87_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().u85_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.h27();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.ea0(views, dt.nj_1);
    return Unit_instance;
  };
}
var Companion_instance_16;
function Companion_getInstance_38() {
  return Companion_instance_16;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.z9z_1;
  var tmp = $this;
  tmp.z9z_1 = lastEventNew == null ? $this.z9z_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.z9z_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.q9y_1.ja0()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.n6e_1;
    tmp_0.r9y_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.y9z_1 = event;
    this$0.z9z_1.u6g(event);
    this$0.aa0_1 = event.q6g_1;
    this$0.x9z_1 = true;
    var tmp_2;
    switch (event.c6g_1.k3_1) {
      case 2:
        this$0.ba0_1.u6g(event);
        this$0.s9z_1 = this$0.ka0().i9p_1.l8a();
        this$0.p9z_1 = PerformanceCounter_getInstance().v6b();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.p9z_1, this$0.q9z_1);
        var tmp_3;
        if (this$0.s9z_1.e2k(this$0.r9z_1) < this$0.ka0().i9p_1.s89_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.ka0().i9p_1.r89_1) < 0) {
          var _unary__edvuaz = this$0.w9z_1;
          this$0.w9z_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.la0()) {
            this$0.t9y_1.u1z(this$0);
            var tmp_5;
            if (this$0.t9y_1.y1z() > 0) {
              event.w6g(this$0.q9y_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.n6g_1) {
          set_mouseDebugLastFrameClicked(this$0.ka0(), true);
        }

        this$0.q9z_1 = PerformanceCounter_getInstance().v6b();
        this$0.r9z_1 = this$0.ka0().i9p_1.l8a();
        var tmp_6;
        if (this$0.s9y_1.z1z()) {
          var tmp_7;
          if (this$0.la0()) {
            this$0.s9y_1.u1z(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.la0()) {
          this$0.i9z_1.u1z(this$0);
        } else {
          this$0.k9z_1.u1z(this$0);
        }

        this$0.j9z_1.u1z(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.z9y_1.u1z(this$0);
      tmp = Unit_instance;
    } else {
      this$0.a9z_1.u1z(this$0);
      this$0.c9z_1.u1z(this$0);
      tmp = Unit_instance;
    }
    this$0.d9z_1.u1z(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.ez_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.dz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.ez_1;
      tmp_0 = tmp0_safe_receiver.z2(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.fz_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.ez_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.ez_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.g86_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.fa1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.b16(), SceneCancellationException.ua0($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.ka0().f9p_1.ym(new InjectorContext(this$0.ga1())).ym(SupervisorJob(this$0.ka0().f9p_1.fd(Key_instance))).ym(CoroutineName.x1c('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.ia1(this$0.ha1().e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.aa1_1.ra3(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.ga1().j6b(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.b16();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.ua3();
  }, null);
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var scene = $this.ya6_1.p9w_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.ya6_1.p9w_1) + ' . doFullReload=' + $this.za6_1.ga7());
    var tmp;
    if ($this.za6_1.ga7()) {
      tmp = $this.za6_1.ha7(getKClassFromExpression(scene), scene.ga1());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.ya6_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.n9w_1;
    var sceneInjector = this_0.m9w_1.h9p_1.c6b().a6b(getKClass(SceneContainer), this_0).a6b(getKClass(Resources), new Resources(this_0.b16(), this_0.m9w_1.o9x().x36_1, this_0.m9w_1.o9x()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.a6b(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.j6b(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.za6_1.c85(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_39().ia7_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.d2x(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.e2x(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.l6b(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.m9w_1.h9p_1.e6b(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.za6_1, scene));
    }
    var tmp_5 = this_0.ka7(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.ka0().m9y(scene_0.ua3());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.j6b($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.c85($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.la7_1.ua3();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.la7_1.ha6(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ma7_1.ua3();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ma7_1.ia6(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.na7_1.ka6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.oa7_1.la6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.oa7_1.ma6();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.pa7_1.na6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.qa7_1.ja6($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.m9w_1.h9p_1.c6b().a6b(getKClass(SceneContainer), $this).a6b(getKClass(Resources), new Resources($this.b16(), $this.m9w_1.o9x().x36_1, $this.m9w_1.o9x()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.a6b(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.j6b(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_39().ia7_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.d2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.e2x(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.l6b(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.m9w_1.h9p_1.e6b(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.ka7(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.p9w_1;
  $this.p9w_1 = newScene;
  $this.o9w_1.caa(newScene.aa1_1, transition);
  try {
    var tmp = newScene.b16();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.b16();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.o9w_1);
    var initial = Companion_getInstance_34().ry_1;
    var end = Companion_getInstance_34().uy_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.o9w_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.o9w_1.za9_1 = Companion_getInstance_34().uy_1;
  }
  $this.o9w_1.daa();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.b16();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.b16();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_17;
function Companion_getInstance_39() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).g1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.p9w_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.j6b($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.qy_1, p1.qy_1, p2.qy_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.za9_1);
  }, function (value) {
    $b0.za9_1 = value.qy_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.baa_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.zah();
  var nextAlpha = next.zah();
  try {
    prev.yah(1.0 - Ratio__toFloat_impl_1ftup5(ratio.qy_1));
    next.yah(Ratio__toFloat_impl_1ftup5(ratio.qy_1));
    prev.fad(ctx);
    next.fad(ctx);
  }finally {
    prev.yah(prevAlpha);
    next.yah(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.ho(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.b75($this$FUNC.o7p($this$FUNC.n7p(a, b), $this$FUNC.n7p($this$FUNC.o7p(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.s73($this$IF_ELSE_BINARY_LOOKUP.v73(), $this$IF_ELSE_BINARY_LOOKUP.d74(Companion_getInstance_6().h8d_1[n], $this$IF_ELSE_BINARY_LOOKUP.b74($$this$buildShader.o73(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.v1w() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.v1w();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.pak(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.v1w() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.iak_1) {
    $this.bak_1.zaf();
  }
  if ($this.lak_1) {
    return $this.uak();
  }
  $this.jak_1 = FastDuration__plus_impl_q1enab($this.jak_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.jak_1, $this.kak_1), 0.0, 1.0);
  $this.pak($this.jak_1);
  $this.fak_1($this.eak_1.ky(ratio));
  var tmp;
  var tmp_0 = $this.vak();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7($this.jak_1, $this.vak()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.wak();
  }
  if (ratio >= 1.0) {
    return $this.uak();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.f8r_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.lak_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.v1w()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.sc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1a();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.xak_1;
  $this.yak_1._v = new TweenComponent(view, toList($this.zak_1), $this.aal_1, $this.bal_1, $this.cal_1, cancellable, $this.dal_1, $this.eal_1);
  var tmp$ret$0 = cancellable.e18();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.h1p($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_33());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.zac_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.bai();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.zac_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_40() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.gao(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.taq_1.g1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.taq_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.d1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.yaq_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y86_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.v8c(it, 'BaseGraphics');
      }
    }
  }
  $this.taq_1.e3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.t59().k2l();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.t59().l2l();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.h29_1 - $this.vag(), bounds.i29_1 - $this.wag(), bounds.j29_1, bounds.k29_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.car_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.xaq_1) {
    $this.xaq_1 = false;
    $this.ear_1 = $this.nat(false);
    $this.dar_1 = $this.nat(true);
  }
  return strokes ? $this.dar_1 : $this.ear_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.w5n();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.ra3(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.hb5();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.lag(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_41() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().w6b())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.ka0().d9r_1;
  tmp.t1z(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.ka0().e9q_1).g8g_1;
  tmp_0.t1z(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.ka0().e9q_1.d87_1.l88_1;
  tmp_1.t1z(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.ka0().e9q_1.d87_1.m88_1;
  tmp_2.t1z(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.ka0();
  tmp_3.kb5(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.o8g_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.c8e() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.o9y();
  var tmp1_colMul = $ctx.c87_1;
  var tmp2_blendMode = Companion_getInstance_13().u85_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.c8h();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().w6b();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.x1w_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7_0(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.rb5(elapsedTime);
        $shortWindow.rb5(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.s9p_1.q8f();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.pb5(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_35().kv() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.e9q_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.f8g_1;
    if (!(this_2.h87_1 === this_1)) {
      this_2.h87_1 = this_1;
      this_2.r88();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.r8g_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().u85_1;
          var doUpdate = !(this_1.q8g_1 === blending);
          var old = this_1.q8g_1;
          try {
            if (doUpdate) {
              this_1.f8g_1.r88();
              this_1.q8g_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().x44_1;
            var oldColor = this_1.i8g_1;
            this_1.i8g_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.w8g(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.w8g(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.i8g_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().h3z_1 : Colors_getInstance().i3z_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.i8g_1;
                this_1.i8g_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.e1() / $longWindow.lb5_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.e1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.e1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.e1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.qb5(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.qb5(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.w8g(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.i8g_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.f8g_1.r88();
            }
            this_1.q8g_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r8g_1;
  }, function (value) {
    $b0.r8g_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.ab8_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.bb8_1 : tmp0_elvis_lhs);
}
function ensure($this) {
  if ($this.hb8_1.k3_1 === 2) {
    if (!($this.ab8_1 == null)) {
      var tmp1_safe_receiver = $this.ab8_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.wai();
      }
      $this.ab8_1 = null;
    }
    if ($this.bb8_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.hbb(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).j4m();
      this_0.ibb(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.jbb($this.cb8_1);
      this_1.iba_1 = $this.fb8_1;
      this_1.kba_1 = $this.eb8_1;
      this_1.ibb($this.gb8_1);
      tmp.bb8_1 = this_1;
    }
  } else {
    if (!($this.bb8_1 == null)) {
      var tmp2_safe_receiver = $this.bb8_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.wai();
      }
      $this.bb8_1 = null;
    }
    if ($this.ab8_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.fb3(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).j4m();
      this_2.gb3(tmp$ret$9);
      if (false) {
        this_2.zat();
      }
      this_2.xaq_1 = true;
      this_2.kai();
      this_2.zat();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.zb2_1 = $this.cb8_1;
      this_2.paq_1 = $this.fb8_1;
      this_2.eaw_1 = $this.eb8_1;
      this_2.gb3($this.gb8_1);
      tmp_0.ab8_1 = this_2;
    }
    var tmp3_safe_receiver = $this.ab8_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.xat($this.hb8_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.bbe($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.ei('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.bau(tmp_0);
    $this.kah(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.bau(tmp$ret$0);
      $this.kah(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.zbd_1.bbe(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.mat_1.g10();
  if (!(source == null)) {
    $this.lat_1 = true;
    $this.raw(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.mbe();
  }, function (value) {
    return $b0.lbe(value);
  });
}
function pos$factory($b0) {
  return getPropertyCallableRef('pos', 0, KMutableProperty0, function () {
    return $b0.ay();
  }, function (value) {
    return $b0.s4r(value);
  });
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r8g_1;
  }, function (value) {
    $b0.r8g_1 = value;
    return Unit_instance;
  });
}
function currentMatrix$factory_1($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r8g_1;
  }, function (value) {
    $b0.r8g_1 = value;
    return Unit_instance;
  });
}
function updateGraphics($this) {
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  // Inline function 'korlibs.korge.view.RoundRect.updateGraphics.<anonymous>' call
  var $this$updatePath = $this.qbj_1;
  $this$updatePath.e3();
  $this$updatePath.f3q(new RoundRectangle(new Rectangle(0.0, 0.0, $this.k2l(), $this.l2l()), $this.obm()));
  $this$updatePath.b3h_1 = true;
  $this.mbj_1 = $this.qbj_1;
  $this.pbm();
}
function RoundRect$unscaledSize$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics(this$0);
    return Unit_instance;
  };
}
function RoundRect$radius$delegate$lambda(this$0) {
  return function (it) {
    updateGraphics(this$0);
    return Unit_instance;
  };
}
function colorMul$factory($b0) {
  return getPropertyCallableRef('colorMul', 0, KMutableProperty0, function () {
    return new RGBA($b0.v4e());
  }, function (value) {
    return $b0.t4e(value.d4f_1);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.ead();
  }, function (receiver, value) {
    return receiver.sbm(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.ead();
  }, function (receiver, value) {
    return receiver.sbm(value);
  });
}
function radius$factory() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.obm();
  }, function (receiver, value) {
    return receiver.tbm(value);
  });
}
function radius$factory_0() {
  return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
    return receiver.obm();
  }, function (receiver, value) {
    return receiver.tbm(value);
  });
}
var Companion_instance_20;
function Companion_getInstance_42() {
  return Companion_instance_20;
}
function anchor$factory($b0) {
  return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
    return $b0.kaw();
  }, function (value) {
    return $b0.gao(value);
  });
}
function antialiased$factory($b0) {
  return getPropertyCallableRef('antialiased', 0, KMutableProperty0, function () {
    return $b0.cb8_1;
  }, function (value) {
    return $b0.jbb(value);
  });
}
function autoScaling$factory($b0) {
  return getPropertyCallableRef('autoScaling', 0, KMutableProperty0, function () {
    return $b0.fb8_1;
  }, function (value) {
    return $b0.obb(value);
  });
}
function renderer$factory($b0) {
  return getPropertyCallableRef('renderer', 0, KMutableProperty0, function () {
    return $b0.hb8_1;
  }, function (value) {
    return $b0.pbb(value);
  });
}
function smoothing$factory($b0) {
  return getPropertyCallableRef('smoothing', 0, KMutableProperty0, function () {
    return $b0.eb8_1;
  }, function (value) {
    return $b0.nbb(value);
  });
}
function boundsIncludeStrokes$factory($b0) {
  return getPropertyCallableRef('boundsIncludeStrokes', 0, KMutableProperty0, function () {
    return $b0.mbb();
  }, function (value) {
    return $b0.naw(value);
  });
}
function anchor$factory_0() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.kaw();
  }, function (receiver, value) {
    return receiver.gao(value);
  });
}
function anchor$factory_1() {
  return getPropertyCallableRef('anchor', 1, KMutableProperty1, function (receiver) {
    return receiver.kaw();
  }, function (receiver, value) {
    return receiver.gao(value);
  });
}
var Companion_instance_21;
function Companion_getInstance_43() {
  return Companion_instance_21;
}
function _set_animationNumberOfFramesRequested__tjl77x($this, value) {
  if (value === 0) {
    $this.zbr();
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if ($this.nbr_1 === _AnimationType___init__impl__l3ftd1(0)) {
      triggerEvent($this, $this.bbs());
    } else {
      triggerEvent($this, $this.abs());
    }
  }
  $this.mbr_1 = value;
}
function _set_animationRemainingDuration__f6834h($this, value) {
  var tmp;
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
  if (FastDuration__compareTo_impl_4fhnj7(value, tmp$ret$1) <= 0) {
    var tmp_0 = $this.nbr_1;
    // Inline function 'korlibs.korge.view.Companion.DURATION' call
    tmp = tmp_0 === _AnimationType___init__impl__l3ftd1(2);
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.zbr();
    triggerEvent($this, $this.obr_1);
  }
  $this.vbr_1 = value;
}
function _set_currentSpriteIndex__7b2y7x($this, value) {
  $this.xbr_1 = umod(value, $this.cbs());
  var tmp0_safe_receiver = $this.wbr_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fbs(value);
  $this.bau(tmp1_elvis_lhs == null ? $this.t59() : tmp1_elvis_lhs);
}
function getDefaultTime($this, spriteAnimation) {
  return !(spriteAnimation == null) && !equals(spriteAnimation.ebs_1, Companion_instance_1.v1w()) ? spriteAnimation.ebs_1 : $this.sbr_1;
}
function nextSprite($this, frameTime) {
  $this.ubr_1 = FastDuration__plus_impl_q1enab($this.ubr_1, frameTime);
  if (FastDuration__compareTo_impl_4fhnj7_0(FastDuration__plus_impl_q1enab($this.ubr_1, frameTime), $this.sbr_1) >= 0) {
    var tmp0_subject = $this.nbr_1;
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    if (tmp0_subject === _AnimationType___init__impl__l3ftd1(0)) {
      if ($this.mbr_1 > 0) {
        var _unary__edvuaz = $this.mbr_1;
        _set_animationNumberOfFramesRequested__tjl77x($this, _unary__edvuaz - 1 | 0);
      }
    } else {
      // Inline function 'korlibs.korge.view.Companion.DURATION' call
      if (tmp0_subject === _AnimationType___init__impl__l3ftd1(2)) {
        _set_animationRemainingDuration__f6834h($this, FastDuration__minus_impl_evs237($this.vbr_1, $this.ubr_1));
      } else {
        // Inline function 'korlibs.korge.view.Companion.LOOPED' call
        _AnimationType___init__impl__l3ftd1(1);
      }
    }
    if ($this.ybr_1) {
      _set_currentSpriteIndex__7b2y7x($this, $this.xbr_1 - 1 | 0);
    } else {
      _set_currentSpriteIndex__7b2y7x($this, $this.xbr_1 + 1 | 0);
    }
    $this.lbr_1 = $this.lbr_1 + 1 | 0;
    triggerEvent($this, $this.rbr_1);
    $this.ubr_1 = get_fastSeconds(0);
  }
}
function updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type) {
  triggerEvent($this, $this.qbr_1);
  $this.sbr_1 = spriteDisplayTime;
  $this.wbr_1 = spriteAnimation;
  $this.tbr_1 = looped;
  _set_animationRemainingDuration__f6834h($this, duration);
  _set_currentSpriteIndex__7b2y7x($this, startFrame);
  $this.ybr_1 = reversed;
  $this.nbr_1 = type;
  $this.kbr_1 = true;
  var endFrame_0 = umod(endFrame, $this.cbs());
  var tmp0_safe_receiver = $this.wbr_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var count = startFrame > endFrame_0 ? reversed ? startFrame - endFrame_0 | 0 : tmp0_safe_receiver.gbs() - (startFrame - endFrame_0 | 0) | 0 : endFrame_0 > startFrame ? reversed ? umod(startFrame - endFrame_0 | 0, tmp0_safe_receiver.gbs()) : endFrame_0 - startFrame | 0 : 0;
    var requestedFrames = count + imul(animationCyclesRequested, tmp0_safe_receiver.gbs()) | 0;
    _set_animationNumberOfFramesRequested__tjl77x($this, requestedFrames);
  }
}
function updateCurrentAnimation$default($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type, $super) {
  spriteDisplayTime = spriteDisplayTime === VOID ? getDefaultTime($this, spriteAnimation) : spriteDisplayTime;
  animationCyclesRequested = animationCyclesRequested === VOID ? 1 : animationCyclesRequested;
  duration = duration === VOID ? get_fastSeconds(0) : duration;
  startFrame = startFrame === VOID ? 0 : startFrame;
  endFrame = endFrame === VOID ? 0 : endFrame;
  looped = looped === VOID ? false : looped;
  reversed = reversed === VOID ? false : reversed;
  var tmp;
  if (type === VOID) {
    // Inline function 'korlibs.korge.view.Companion.STANDARD' call
    tmp = _AnimationType___init__impl__l3ftd1(0);
  } else {
    tmp = type;
  }
  type = tmp;
  return updateCurrentAnimation($this, spriteAnimation, spriteDisplayTime, animationCyclesRequested, duration, startFrame, endFrame, looped, reversed, type);
}
function triggerEvent($this, signal) {
  if (!(signal == null)) {
    var tmp0_safe_receiver = $this.wbr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      signal.u1z(tmp0_safe_receiver);
    }
  }
}
function Sprite$lambda($this$addFastUpdater, frameTime) {
  if ($this$addFastUpdater.kbr_1) {
    nextSprite($this$addFastUpdater, frameTime.x1w_1);
  }
  return Unit_instance;
}
function _AnimationType___init__impl__l3ftd1(id) {
  return id;
}
var Companion_instance_22;
function Companion_getInstance_44() {
  return Companion_instance_22;
}
var Companion_instance_23;
function Companion_getInstance_45() {
  return Companion_instance_23;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.q9q_1;
  }, function (value) {
    $b0.q9q_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.tbs();
  }, function (value) {
    return $b0.ubs(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5n();
  }, function (receiver, value) {
    return receiver.sbs(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.w5n();
  }, function (receiver, value) {
    return receiver.sbs(value);
  });
}
function unscaledSize$factory_1() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.ead();
  }, function (receiver, value) {
    return receiver.sbm(value);
  });
}
function unscaledSize$factory_2() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.ead();
  }, function (receiver, value) {
    return receiver.sbm(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.j4g()) {
    case 'msdf':
      return MsdfRender_getInstance().vaj_1;
    case 'psdf':
      return MsdfRender_getInstance().yaj_1;
    case 'sdf':
      return MsdfRender_getInstance().yaj_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.vbs_1.tbw(ensureNotNull(get_views($this.wbs_1)).c9q_1, $this.xbs_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_24;
function Companion_getInstance_46() {
  return Companion_instance_24;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.wbw();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.kbv_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.xbw(sourceFile);
  $this.xbv_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.ei('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.ybw(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.il();
  var y = pos.jl();
  if ($this.cbw_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.ubv_1.z4o_1, $this.bbw_1.j29_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.ubv_1.a4p_1, $this.bbw_1.k29_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.vbv_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.pbv_1;
  }, function (value) {
    return $b0.bbx(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.abw_1;
  }, function (value) {
    return $b0.xbw(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.h4g();
  }, function (receiver, value) {
    return receiver.cbx(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.h4g();
  }, function (receiver, value) {
    return receiver.cbx(value);
  });
}
var Companion_instance_25;
function Companion_getInstance_47() {
  return Companion_instance_25;
}
function updateRenderColorTransform($this) {
  $this.e9t_1 = $this.j9t_1;
  $this.l9t_1 = true;
  var parent = $this.h27();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.d9t_1.w4e($this.c9t_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.d9t_1.x4e($this.c9t_1, parent.gai());
    } else {
      $this.d9t_1.w4e($this.c9t_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.e9t_1 === $this.j9t_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.g9t_1 = $this.i9t_1;
  $this.k9t_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.i9s_1.equals(Companion_getInstance_13().l85_1)) {
    var tmp1_safe_receiver = $this.h27();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hai();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().k85_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.i9s_1;
  }
  tmp.f9t_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.g9t_1 === $this.i9t_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.u1w() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.v6d(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_26;
  return _this__u8e3s4.v6d(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.h27();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.d2b(x, y));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.i1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.w9r_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.cag();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.d1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.h27();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.h27();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.h27();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.s4r(p);
  return _this__u8e3s4;
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().oj_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.v6d(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.f8r_1, $this_addFastUpdater.fah())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.kbx_1, new Duration(Duration__times_impl_sfuzvp(it.mbx(), $this_addUpdaterWithViews.fah())));
    return Unit_instance;
  };
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.g8r(), $this_addUpdater.fah())));
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.lah();
  }, function (value) {
    return $b0.kah(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.uag();
  }, null);
}
function currentMatrix$factory_2($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.r8g_1;
  }, function (value) {
    $b0.r8g_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.nbx_1.jbe(ensureNotNull(get_views($this.obx_1)), VOID, $this.pbx_1.dbe_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.rbx_1.sbx($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.a9q_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().j85();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.n9q_1;
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.d1(_unary__edvuaz).t1q($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.n9q_1.e3();
  cancel($this.f9p_1);
  $this.l9p_1.n8p();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.q9o(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.n9p_1 == null) ? ensureNotNull(this$0.n9p_1) : StandardPaths_instance.z31(this$0.tbx());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.uz();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.e9q_1.u8c();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.e9q_1.l8h();
    return Unit_instance;
  };
}
var Companion_instance_26;
function Companion_getInstance_48() {
  return Companion_instance_26;
}
var Companion_instance_27;
function Companion_getInstance_49() {
  return Companion_instance_27;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.w9p_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.f8r_1 = delta;
  _this__u8e3s4.g6e(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.x9p_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.lbx_1 = delta;
  _this__u8e3s4.g6e(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().g2j() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_25().k28() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.l2u(reqVirtualSize_0);
  targetSize.l2u(scaleMode.j2j(virtualSize.n1(), actualSize_0));
  var ratioX = targetSize.n1().o2j_1 / reqVirtualSize_0.o2j_1;
  var ratioY = targetSize.n1().p2j_1 / reqVirtualSize_0.p2j_1;
  var actualVirtualWidth = toIntRound(actualSize_0.o2j_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.p2j_1 / ratioY);
  _this__u8e3s4.t8f(Companion_getInstance_30().f2c_1.h2d(ratioX, ratioY).p2d(toIntRound((actualVirtualWidth - reqVirtualSize_0.o2j_1 | 0) * anchor.h28_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.p2j_1 | 0) * anchor.i28_1)));
  _this__u8e3s4.p8f(_this__u8e3s4.u8f().r2d());
  _this__u8e3s4.v8f(_this__u8e3s4.u8f().s2d());
  _this__u8e3s4.r8f(_this__u8e3s4.q8f().s2d());
  var tl = _this__u8e3s4.a8g(Vector2D.q2b(0, 0));
  var br = _this__u8e3s4.a8g(Vector2D.d2b(actualSize_0.o2j_1, actualSize_0.p2j_1));
  _this__u8e3s4.x8f(Companion_getInstance_28().e2h(tl.x28_1, tl.y28_1, br.x28_1, br.y28_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.j6b(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.a8h();
  }, function (value) {
    return $b0.h8p(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.r8p();
  }, function (value) {
    return $b0.q8p(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.b87_1;
  }, function (value) {
    $b0.b87_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.c87_1);
  }, function (value) {
    $b0.c87_1 = value.d4f_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.f8n_1;
  }, function (value) {
    $b0.f8n_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.j9x();
  }, function (receiver, value) {
    return receiver.p9x(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.j9x();
  }, function (receiver, value) {
    return receiver.p9x(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ybx();
  }, function (receiver, value) {
    return receiver.f9x(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.ybx();
  }, function (receiver, value) {
    return receiver.f9x(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.zbx());
  }, function (receiver, value) {
    return receiver.g9x(value.d4f_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.zbx());
  }, function (receiver, value) {
    return receiver.g9x(value.d4f_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.a9r_1;
  }, function (value) {
    $b0.a9r_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.c9r_1;
  }, function (value) {
    $b0.c9r_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.fby();
  }, function (receiver, value) {
    return receiver.mby(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.fby();
  }, function (receiver, value) {
    return receiver.mby(value);
  });
}
var renderToTextureResultPool$delegate;
var Companion_instance_28;
function Companion_getInstance_50() {
  if (Companion_instance_28 === VOID)
    new Companion_13();
  return Companion_instance_28;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.b2i(getBorder(_this__u8e3s4, toIntCeil(inp.j29_1), toIntCeil(inp.k29_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.qby(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.c2t(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.m19();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_29;
function Companion_getInstance_51() {
  if (Companion_instance_29 === VOID)
    new Companion_14();
  return Companion_instance_29;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.o9t_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ebz_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.iz_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.gz_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.l9y(VOID, false);
  if (bounds.j29_1 <= 0.0 || bounds.k29_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_50();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.pby();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.oby(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.j29_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.k29_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.j29_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.h29_1 + edgeSize;
  var addy = -bounds.i29_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.r88();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.n8h(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.p8h(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.d87_1;
      var this_1 = this_0.m87_1;
      if (!(this_1.h87_1 === this_0)) {
        this_1.h87_1 = this_0;
        this_1.r88();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.i6x(0, 0, rb.l6m_1, rb.m6m_1);
        var temp = this_0.k88_1;
        this_0.u8e();
        this_0.k88_1 = scissor;
        try {
          if (true) {
            ctx.i8h(Colors_getInstance().m3z_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.fai().l2d(addx, addy).g2d(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.d87_1.m87_1;
          this_2.r88();
          var temp4 = this_2.s86_1;
          var temp2d = this_2.t86_1;
          this_2.t86_1 = mat;
          this_2.s86_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.u6t(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.j6v();
            this_3.a7i(_unary__edvuaz + 1 | 0);
            this_3.b7i(this_3.j6v() + 1 | 0);
            var blockSize = this_3.n6t_1;
            var index0 = imul(this_3.j6v() - 1 | 0, blockSize);
            var index1 = imul(this_3.j6v(), blockSize);
            var texBlockSize = this_3.k6t_1.j71().e1();
            var texIndex0 = imul(this_3.j6v() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.j6v(), texBlockSize);
            if (this_3.j6v() > 0) {
              arraycopy(this_3.p6t_1, index0, this_3.p6t_1, index1, blockSize);
            } else {
              arrayfill(this_3.p6t_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.k6t_1;
            this_3.q6t_1.k7i($this$push.i71(), this_2.s86_1);
            if (true && this_3.j6v() >= 1) {
              var equals = arrayequal(this_3.p6t_1, index0, this_3.p6t_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.j6v();
                this_3.a7i(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.nai(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.oai(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.r88();
            this_2.s86_1 = temp4;
            this_2.t86_1 = temp2d;
            this_2.u6t(ProjViewUB_getInstance()).c7i();
          }
          break $l$block_0;
        }finally {
          this_0.u8e();
          this_0.k88_1 = temp;
        }
      }
    }finally {
      ctx.q8h();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).h3k(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.n9y().p2d(-addx, -addy).i2d(1.0 / realFilterScale);
    filter.rby(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.iai(), _this__u8e3s4.i9s_1, realFilterScale);
    ctx.r88();
  }finally {
    ctx.o8h(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.o9t_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fbz_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_50().oby(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.iz_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.lba_1 ? $this.wba_1 : $this.vba_1;
  if (!valid) {
    if ($this.lba_1)
      $this.wba_1 = true;
    else
      $this.vba_1 = true;
    var result = $this.tba_1.o5n($this.lba_1);
    if ($this.lba_1)
      $this.zba_1 = result;
    else
      $this.yba_1 = result;
    return result;
  }
  return $this.lba_1 ? $this.zba_1 : $this.yba_1;
}
function invalidateShape($this) {
  $this.xba_1 = 0;
  $this.uba_1 = false;
  $this.vba_1 = false;
  $this.wba_1 = false;
  $this.zaf();
}
function requireShape($this) {
  if ($this.uba_1)
    return Unit_instance;
  $this.uba_1 = true;
  $this.mba_1.e3();
  $this.mba_1.qbz();
  $this.mba_1.rbz(Companion_getInstance_14().e6o_1);
  $this.abb_1 = true;
  renderShape($this, $this.tba_1);
  $this.mba_1.u6m();
  $this.cbb_1 = $this.bbb_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.n9y().t2c(get_immutable(ctx.g86_1.u8f())) : $this.n9y();
  $this.dbb_1 = mat.n2d(-$this.vag(), -$this.wag());
  requireShape($this);
  $this.mba_1.sbz(ctx, $this.dbb_1, $this.eai(), $this.qba_1, $this.iai(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.b5o_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var v = _iterator__ex2g4s.c1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.u5o());
      } else {
        if (shape instanceof FillShape) {
          $this.xba_1 = $this.xba_1 + 1 | 0;
          if ($this.xba_1 > $this.ebb_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.xba_1 = $this.xba_1 + 1 | 0;
            if ($this.xba_1 > $this.ebb_1)
              return Unit_instance;
            renderStroke$default($this, shape.g5o_1, shape.d5o_1, shape.f5o_1, shape.i5o_1, shape.h5o_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.ud('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.mba_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.rbz(Companion_getInstance_14().e6o_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.d1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.tbz();
    var vector = points.q3b();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.f2b(n_0, 0);
        var y = vector.f2b(n_0, 1);
        var dx = vector.f2b(n_0, 2);
        var dy = vector.f2b(n_0, 3);
        var len = vector.f2b(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.f2b(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.ubz(px, py, $this.sba_1 ? len : 0.0, $this.sba_1 ? maxLen : $this.gbb_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.vbz();
    var info = GpuShapeViewPrograms_getInstance().oc0(stateTransform, paint, globalAlpha, strokeInfo.z3a_1);
    var tmp0_drawType = Companion_getInstance_16().g6w_1;
    var tmp1_blendMode = Companion_getInstance_13().k85_1;
    gpuShapeViewCommands.pc0(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().s6n_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_18().q6n_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.e1() < 3)
    return null;
  var vertexStart = $this.mba_1.tbz();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_29().x29(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.d2b(xMid, yMid);
  var isStrip = type === Companion_getInstance_16().g6w_1;
  var antialiased = $this.sba_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.mba_1.ubz(xMid, yMid, 0.0, $this.gbb_1);
  }
  var inductionVariable = 0;
  var last = points.e1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.d1(n % points.e1() | 0);
      var x = p.il();
      var y = p.jl();
      var len = isStripAndAntialiased ? Companion_getInstance_27().z2j(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.gbb_1;
      if (isStrip) {
        $this.mba_1.ubz(xMid, yMid, 0.0, maxLen);
      }
      $this.mba_1.ubz(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.mba_1.vbz();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.e1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.i1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().oc0(shape.s5n_1, shape.r5n_1, shape.t5n_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.fbb_1;
  var drawAntialiasingBorder = $this.fbb_1 ? true : $this.sba_1;
  var shapeIsConvex = shape.z5n();
  var isSimpleDraw = shapeIsConvex && shape.q5n_1 == null && !$this.fbb_1;
  var pathDataList = getPointsForPathList($this, shape.p5n_1, isSimpleDraw ? Companion_getInstance_16().g6w_1 : Companion_getInstance_16().h6w_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_29().x29();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.e1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.d1(_unary__edvuaz);
    bb = plus(bb, it.qc0_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.b2i(MarginInt.b2c(2)));
  var clipDataStart = $this.mba_1.tbz();
  var tmp1_safe_receiver = shape.q5n_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_16().h6w_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.mba_1.vbz();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.qc0_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_14().e6o_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.abb_1) {
    $this.abb_1 = true;
    $this.mba_1.rbz(isSimpleDraw ? Companion_getInstance_14().e6o_1 : !clipBounds.equals(Companion_getInstance_14().e6o_1) ? Companion_getInstance_14().n6x(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.abb_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.e1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.d1(_unary__edvuaz_0);
      var tmp0_$this = $this.mba_1;
      var tmp1_drawType = Companion_getInstance_16().g6w_1;
      var tmp2_startIndex = pathData.sc0_1;
      var tmp3_endIndex = pathData.tc0_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.hai();
      tmp0_$this.pc0(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.p5n_1.z3g_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_19().h6y_1;
  if (drawFill) {
    switch (winding.k3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_19().h6y_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), Companion_getInstance_19().g6y_1), Companion_getInstance_20().s6y_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().q6n_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.d1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.sc0_1, pathData_0.tc0_1, stencilOpFunc, stencilRef, Companion_getInstance_21().g6o_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_19().n6y_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), Companion_getInstance_19().g6y_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().q6n_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.e1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.d1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.sc0_1, pathData_1.tc0_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_20().r6y_1, Companion_getInstance_20().p6y_1), stencilRef_0, Companion_getInstance_21().g6o_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), Companion_getInstance_19().n6y_1), Companion_getInstance_20().s6y_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_18().q6n_1, 0), 255), Companion_getInstance_21().h6o_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), Companion_getInstance_19().g6y_1), Companion_getInstance_20().s6y_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().q6n_1, 2), Companion_getInstance_21().j6o_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.q5n_1 == null) {
    renderStroke($this, shape.s5n_1, shape.p5n_1, shape.r5n_1, shape.t5n_1, new StrokeInfo(1.6 / $this.bbb_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_17().s6n_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().q6n_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.mba_1.o7c(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.mba_1;
  var tmp1_drawType = Companion_getInstance_16().h6w_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().nc0_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().m85_1;
  tmp0_$this.uc0(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.mba_1.tbz();
  var x0 = pathBounds.o29();
  var y0 = pathBounds.q29();
  var x1 = pathBounds.p29();
  var y1 = pathBounds.r29();
  $this.mba_1.ubz(x0, y0, 0.0, $this.gbb_1);
  $this.mba_1.ubz(x1, y0, 0.0, $this.gbb_1);
  $this.mba_1.ubz(x1, y1, 0.0, $this.gbb_1);
  $this.mba_1.ubz(x0, y1, 0.0, $this.gbb_1);
  var vend = $this.mba_1.vbz();
  var tmp0_$this = $this.mba_1;
  var tmp1_drawType = Companion_getInstance_16().h6w_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().s6n_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().q6n_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.hai();
  tmp0_$this.pc0(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.v73(), GpuShapeViewPrograms_getInstance().ac2());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.v73(), $this$IF_ELSE_LIST.d74($$this$FragmentShaderDefault.c74(), $this$IF_ELSE_LIST.j75($this$IF_ELSE_LIST.l75([$this$IF_ELSE_LIST.b74($this$IF_ELSE_LIST.w73(GpuShapeViewPrograms_getInstance().cc2(), $this$IF_ELSE_LIST.z73([$$this$FragmentShaderDefault.o73(), $this$IF_ELSE_LIST.y73(0.0), $this$IF_ELSE_LIST.y73(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.v73(), $this$IF_ELSE_LIST.d74($$this$FragmentShaderDefault.c74(), $this$IF_ELSE_LIST.b74($this$IF_ELSE_LIST.w73(GpuShapeViewPrograms_getInstance().cc2(), $this$IF_ELSE_LIST.z73([$this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.y73(0.0), $this$IF_ELSE_LIST.y73(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.d75(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.b74(rpoint, 'xy'), $this$IF_ELSE_LIST.b74($this$IF_ELSE_LIST.w73(GpuShapeViewPrograms_getInstance().cc2(), $this$IF_ELSE_LIST.z73([$this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.y73(0.0), $this$IF_ELSE_LIST.y73(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.m75(rpoint);
        var y = $this$IF_ELSE_LIST.n75(rpoint);
        var x0 = $this$IF_ELSE_LIST.m75(GpuShapeViewPrograms_getInstance().dc2());
        var y0 = $this$IF_ELSE_LIST.n75(GpuShapeViewPrograms_getInstance().dc2());
        var r0 = $this$IF_ELSE_LIST.o75(GpuShapeViewPrograms_getInstance().dc2());
        var x1 = $this$IF_ELSE_LIST.m75(GpuShapeViewPrograms_getInstance().ec2());
        var y1 = $this$IF_ELSE_LIST.n75(GpuShapeViewPrograms_getInstance().ec2());
        var r1 = $this$IF_ELSE_LIST.o75(GpuShapeViewPrograms_getInstance().ec2());
        var ratio = $this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.g74());
        var r0r1_2 = $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.g74());
        var r0pow2 = $this$IF_ELSE_LIST.o75($$this$FragmentShaderDefault.g74());
        var r1pow2 = $this$IF_ELSE_LIST.p75($$this$FragmentShaderDefault.g74());
        var y0_y1 = $this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.x75());
        var x0_x1 = $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.x75());
        var r0_r1 = $this$IF_ELSE_LIST.o75($$this$FragmentShaderDefault.x75());
        var radial_scale = $this$IF_ELSE_LIST.p75($$this$FragmentShaderDefault.x75());
        $this$IF_ELSE_LIST.s73(r0r1_2, $this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.y73(2.0), r0), r1));
        $this$IF_ELSE_LIST.s73(r0pow2, GpuShapeViewPrograms_getInstance().fc2(r0));
        $this$IF_ELSE_LIST.s73(r1pow2, GpuShapeViewPrograms_getInstance().fc2(r1));
        $this$IF_ELSE_LIST.s73(x0_x1, $this$IF_ELSE_LIST.r75(x0, x1));
        $this$IF_ELSE_LIST.s73(y0_y1, $this$IF_ELSE_LIST.r75(y0, y1));
        $this$IF_ELSE_LIST.s73(r0_r1, $this$IF_ELSE_LIST.r75(r0, r1));
        $this$IF_ELSE_LIST.s73(radial_scale, $this$IF_ELSE_LIST.h74($this$IF_ELSE_LIST.y73(1.0), $this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.r75(GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(r0, r1)), GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(x0, x1))), GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(y0, y1)))));
        $this$IF_ELSE_LIST.s73(ratio, $this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.y73(1.0), $this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.q75(r1), r0_r1), $this$IF_ELSE_LIST.w73(x0_x1, $this$IF_ELSE_LIST.r75(x1, x))), $this$IF_ELSE_LIST.w73(y0_y1, $this$IF_ELSE_LIST.r75(y1, y))), $this$IF_ELSE_LIST.h75($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.w73(r1pow2, $this$IF_ELSE_LIST.s75(GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(x0, x)), GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(y0, y)))), $this$IF_ELSE_LIST.w73(r0r1_2, $this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.r75(x0, x), $this$IF_ELSE_LIST.r75(x1, x)), $this$IF_ELSE_LIST.w73($this$IF_ELSE_LIST.r75(y0, y), $this$IF_ELSE_LIST.r75(y1, y))))), $this$IF_ELSE_LIST.w73(r0pow2, $this$IF_ELSE_LIST.s75(GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(x1, x)), GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75(y1, y))))), GpuShapeViewPrograms_getInstance().fc2($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.s75($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.r75($this$IF_ELSE_LIST.w73(x1, y0), $this$IF_ELSE_LIST.w73(x, y0)), $this$IF_ELSE_LIST.w73(x0, y1)), $this$IF_ELSE_LIST.w73(x, y1)), $this$IF_ELSE_LIST.w73(x0, y)), $this$IF_ELSE_LIST.w73(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.v73(), $this$IF_ELSE_LIST.d74($$this$FragmentShaderDefault.c74(), $this$IF_ELSE_LIST.l75([ratio, $this$IF_ELSE_LIST.y73(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.d75(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.b74(rpoint_0, 'xy'), $this$IF_ELSE_LIST.b74($this$IF_ELSE_LIST.w73(GpuShapeViewPrograms_getInstance().cc2(), $this$IF_ELSE_LIST.z73([$this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.o73()), $this$IF_ELSE_LIST.y73(0.0), $this$IF_ELSE_LIST.y73(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.m75(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.n75(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.m75($$this$FragmentShaderDefault.g74());
        var angle = $this$IF_ELSE_LIST.n75($$this$FragmentShaderDefault.g74());
        var x0_0 = $this$IF_ELSE_LIST.m75(GpuShapeViewPrograms_getInstance().dc2());
        var y0_0 = $this$IF_ELSE_LIST.n75(GpuShapeViewPrograms_getInstance().dc2());
        var PI2 = $this$IF_ELSE_LIST.y73(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.s73(angle, $this$IF_ELSE_LIST.f75($this$IF_ELSE_LIST.r75(y_0, y0_0), $this$IF_ELSE_LIST.r75(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.u75(angle, $this$IF_ELSE_LIST.y73(0.0));
        var body = $this$IF_ELSE_LIST.j74();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.s73(angle, body.s75(angle, PI2));
        var stmIf = new If(cond, body.l74());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.r73_1.h(stmIf);
        $this$IF_ELSE_LIST.s73(ratio_0, $this$IF_ELSE_LIST.h74(angle, PI2));
        $this$IF_ELSE_LIST.s73($this$IF_ELSE_LIST.v73(), $this$IF_ELSE_LIST.d74($$this$FragmentShaderDefault.c74(), $this$IF_ELSE_LIST.j75($this$IF_ELSE_LIST.l75([ratio_0, $this$IF_ELSE_LIST.y73(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.zc1();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.ac2();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.yc1();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.bc2();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.xc1();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.cc2();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.dc2();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.ec2();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.zc1();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.ac2();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.yc1();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.bc2();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.xc1();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.cc2();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.dc2();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.ec2();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.vaw);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.sa3);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.waw);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.fao);
initMetadataForClass(UIView, 'UIView', UIView.aad);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.bad);
protoOf(Transition$1).kaj = start;
protoOf(Transition$1).laj = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForClass(UIObservable, 'UIObservable');
initMetadataForCompanion(Companion_3);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.obe);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.fb3);
initMetadataForClass(DummyView, 'DummyView', DummyView.hb5);
initMetadataForCompanion(Companion_4);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.jb5);
initMetadataForClass(SContainer, 'SContainer', SContainer.ga6);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.kbb);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).jbe = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForClass(Line, 'Line');
initMetadataForClass(ShapeView, 'ShapeView', ShapeView.rbm);
initMetadataForClass(RoundRect, 'RoundRect');
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Sprite, 'Sprite', Sprite.hbs);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(SpriteAnimation, 'SpriteAnimation', VOID, VOID, [Collection]);
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_9);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_10);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).jbe = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_12);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_13);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).pby = get_recommendedFilterScale;
protoOf(IdentityFilter).qby = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.hbb);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_16 = new Companion_1();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
Companion_instance_26 = new Companion_11();
Companion_instance_27 = new Companion_12();
//endregion
//region block: exports
export {
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_instance_24 as Companion_instance1qzytx5vkv693,
  Companion_getInstance_37 as Companion_getInstance1wjuqlbt5kx1j,
  get_keys as get_keysmipauarvwdlb,
  get_mouse as get_mouse1jstwhfaumelj,
  Container as Container7486fjmip554,
  Line as Lineazu98ookfk8s,
  RoundRect as RoundRect16qm0yoxjizxs,
  SolidRect as SolidRect131p7hyzlx7j8,
  SpriteAnimation as SpriteAnimationagta0d6ji85w,
  Sprite as Sprite19oods84ct31j,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  position as positionu6441b7hkb4l,
};
//endregion
